var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInitiate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-5",
    d: "M76.39,423c-95.87-55.35-95.88-145.1,0-200.45s251.32-55.36,347.2,0,95.88,145.1,0,200.45S172.27,478.38,76.39,423Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.87,337.94c-8-4.63-12.36-6-14.41-6.35A14.53,14.53,0,0,1,335,341.8a32.43,32.43,0,0,1-30,0c-5.16-3-8.12-7.5-8.12-12.41s3-9.44,8.12-12.42A25.79,25.79,0,0,1,315,313.86c-1-.62-2.11-1.31-3.41-2.06L282,294.73l31.64-18.27c9.58-5.52,16.82-8.21,22.16-8.21,7.08,0,10.38,4.5,11.1,8.71.45,2.7.45,2.7,1.61,3.37a19.7,19.7,0,0,0,17.09,0,5.42,5.42,0,0,0,1.52-1.19,5.23,5.23,0,0,0-1.52-1.19c-2.35-1.36-5.31-1.59-10.78-1.9-8.32-.47-10.93-4.22-11.66-7.28-1.62-6.82,5.13-12.31,15.75-18.44l25.16-14.53,23.09,13.33c10.62,6.13,17.36,11.62,15.74,18.44-.73,3.06-3.34,6.81-11.65,7.28-5.47.31-8.44.54-10.79,1.9a5.39,5.39,0,0,0-1.52,1.19,5.58,5.58,0,0,0,1.52,1.19,19.7,19.7,0,0,0,17.09,0c1.16-.67,1.16-.67,1.62-3.36.72-4.22,4-8.72,11.1-8.72,5.33,0,12.58,2.69,22.15,8.22L482,292.34,450.39,310.6c-1.3.75-2.43,1.44-3.42,2.06a25.59,25.59,0,0,1,10.11,3.12c5.17,3,8.13,7.5,8.13,12.41s-3,9.43-8.13,12.41a32.41,32.41,0,0,1-30,0,14.53,14.53,0,0,1-7.5-10.2c-2.06.37-6.4,1.71-14.42,6.34L380,351.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.83,262.45c-10.51-6.09-17.17-11.54-15.55-18.33.73-3.06,3.35-6.81,11.65-7.28,5.47-.31,8.43-.53,10.79-1.89a5.58,5.58,0,0,0,1.52-1.19,5.36,5.36,0,0,0-1.52-1.2,19.7,19.7,0,0,0-17.09,0c-1.16.67-1.16.67-1.62,3.36-.72,4.22-4,8.72-11.1,8.72-5.29,0-12.47-2.65-21.95-8.09l-29.77-17.19,31.64-18.27c9.58-5.53,16.82-8.21,22.16-8.21,7.08,0,10.38,4.5,11.1,8.71.46,2.7.46,2.7,1.62,3.37a19.7,19.7,0,0,0,17.09,0,5.72,5.72,0,0,0,1.52-1.2,5.76,5.76,0,0,0-1.52-1.19c-2.36-1.36-5.32-1.58-10.79-1.89-8.31-.48-10.93-4.23-11.66-7.29-1.62-6.82,5.13-12.3,15.75-18.43l25.16-14.53,23.09,13.33c8,4.63,12.36,6,14.41,6.34a14.56,14.56,0,0,1,7.5-10.21,32.43,32.43,0,0,1,30.05,0c5.16,3,8.12,7.51,8.12,12.42s-3,9.43-8.12,12.41a25.41,25.41,0,0,1-10.11,3.11c1,.63,2.11,1.31,3.41,2.06L350.18,217l-31.64,18.27c-1.3.75-2.43,1.43-3.42,2.06a25.67,25.67,0,0,1,10.12,3.11c5.16,3,8.12,7.51,8.12,12.42s-3,9.43-8.12,12.41a30.5,30.5,0,0,1-15,3.69h0a30.46,30.46,0,0,1-15-3.69,14.53,14.53,0,0,1-7.5-10.21c-2.06.38-6.4,1.72-14.42,6.34l-25.16,14.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.38,416.17c-8-4.63-12.36-6-14.41-6.34a14.56,14.56,0,0,1-7.5,10.21,32.51,32.51,0,0,1-30.05,0c-5.16-3-8.12-7.51-8.12-12.42s3-9.43,8.12-12.41a25.64,25.64,0,0,1,10.11-3.12c-1-.62-2.11-1.3-3.41-2L145.55,373l31.64-18.27c1.3-.75,2.43-1.44,3.42-2.06a25.74,25.74,0,0,1-10.11-3.11c-5.17-3-8.13-7.51-8.13-12.42s3-9.43,8.13-12.41a32.41,32.41,0,0,1,30,0,14.5,14.5,0,0,1,7.5,10.2c2.06-.37,6.4-1.71,14.42-6.34L247.62,314l23.09,13.33c10.62,6.13,17.36,11.61,15.74,18.43-.73,3.06-3.34,6.81-11.65,7.29-5.47.31-8.43.53-10.79,1.89a5.58,5.58,0,0,0-1.52,1.19,5.55,5.55,0,0,0,1.52,1.2,19.7,19.7,0,0,0,17.09,0c1.16-.68,1.16-.68,1.62-3.37.72-4.21,4-8.72,11.1-8.72,5.33,0,12.58,2.69,22.15,8.22l29.57,17.07L313.9,388.84c-9.58,5.53-16.82,8.21-22.16,8.21-7.08,0-10.38-4.5-11.09-8.72-.46-2.69-.46-2.69-1.62-3.36a19.7,19.7,0,0,0-17.09,0,5.42,5.42,0,0,0-1.52,1.19,5.21,5.21,0,0,0,1.52,1.2c2.35,1.36,5.31,1.58,10.78,1.89,8.32.47,10.93,4.22,11.66,7.29,1.62,6.82-5.12,12.3-15.75,18.43L243.47,429.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8,340.2c-10.62-6.13-17.36-11.62-15.74-18.44.73-3.06,3.34-6.81,11.65-7.28,5.47-.31,8.43-.54,10.78-1.9A5.42,5.42,0,0,0,97,311.39a5.23,5.23,0,0,0-1.52-1.19A17.67,17.67,0,0,0,87,308.25a17.67,17.67,0,0,0-8.54,1.95c-1.16.67-1.16.67-1.62,3.36-.72,4.22-4,8.72-11.1,8.72-5.33,0-12.58-2.69-22.16-8.22L14,297l31.64-18.26c1.3-.75,2.43-1.44,3.42-2.06a25.64,25.64,0,0,1-10.12-3.12c-5.16-3-8.12-7.5-8.12-12.41s3-9.44,8.12-12.42a30.6,30.6,0,0,1,15-3.68,30.56,30.56,0,0,1,15,3.68,14.56,14.56,0,0,1,7.5,10.21c2.05-.37,6.4-1.71,14.41-6.34L116,238.06l23.28,13.45c7.89,4.53,12.18,5.86,14.21,6.23A14.54,14.54,0,0,1,161,247.53a32.41,32.41,0,0,1,30,0c5.17,3,8.13,7.5,8.13,12.41s-3,9.44-8.13,12.42a25.74,25.74,0,0,1-10.1,3.11c.93.59,2,1.24,3.22,1.95L214,294.6l-31.64,18.27c-9.58,5.52-16.82,8.21-22.16,8.21h0c-7.08,0-10.38-4.5-11.1-8.72-.46-2.69-.46-2.69-1.62-3.36a19.7,19.7,0,0,0-17.09,0,5.76,5.76,0,0,0-1.52,1.19,5.72,5.72,0,0,0,1.52,1.2c2.36,1.35,5.32,1.58,10.79,1.89,8.31.47,10.93,4.22,11.65,7.28,1.63,6.82-5.12,12.31-15.74,18.44l-25.16,14.53Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M58.24,401.1l9.2-5.33a11.07,11.07,0,0,1,10,0l3.21,1.85,12-6.91a4.36,4.36,0,0,1,3.92,0l.08.05a1.19,1.19,0,0,1,0,2.26l-12,6.91.67.38c2.77,1.6,2.77,4.2,0,5.81l-9.2,5.33L62.72,419.2,44.81,408.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M132,404.28a2.09,2.09,0,0,0-.16-.27l-.11-.17-.13-.18-.31-.4c-.12-.14-.26-.29-.41-.44a9.56,9.56,0,0,0-1.08-.93l-.2-.13,0,0-.18-.1a7.28,7.28,0,0,0-2.68-.93l-.47-.05h-.47l-.48,0-.21,0-.18,0-.09,0-.13,0a1.81,1.81,0,0,0-.31.09h0a3.61,3.61,0,0,0-.42.16h0a5.56,5.56,0,0,0-.75.41,8,8,0,0,0-1.36,1.14c-.19.2-.36.4-.52.6s-.43.61-.61.9a5.83,5.83,0,0,0-.32.6l-.15.29c-.18.38-.34.75-.49,1.08-.65.31-27.14,15.52-32.94,19.08l0,0-.74.46c-7.61,4.75-16.35,12.85-16.35,12.85h0l-.1.11a.67.67,0,0,0,.16.95.68.68,0,0,0,.6.1h0a123.3,123.3,0,0,0,18.56-9.19c6.13-3.82,31.54-20.75,32.56-21.56a7.34,7.34,0,0,0,4.11-.22A7.22,7.22,0,0,0,129,406h0a4.78,4.78,0,0,1,.74-.75,2.94,2.94,0,0,1,2.4-.72A2.49,2.49,0,0,0,132,404.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M83.68,417.57a145.09,145.09,0,0,0-14.56,14.84h0a1.25,1.25,0,0,0-.09.12.68.68,0,0,0,.89.94h0A122.42,122.42,0,0,0,87.19,422c4.14-3.4,8.06-7.11,10.61-9.62h0c1.08-1,2.09-2,3-3h0a7.34,7.34,0,0,0,4-.75,7.22,7.22,0,0,0,3.08-3.09h0a5,5,0,0,1,.64-.84,2.93,2.93,0,0,1,2.28-1l-.15-.22-.2-.25-.13-.15-.15-.16h0l-.36-.36c-.14-.12-.29-.25-.46-.38a7.79,7.79,0,0,0-1.2-.78l-.2-.11-.06,0-.19-.08a7.35,7.35,0,0,0-2.78-.58l-.46,0-.47.05a3.56,3.56,0,0,0-.47.1l-.21,0-.17.06-.09,0-.12,0-.3.13h0l-.39.21h0a4.09,4.09,0,0,0-.69.51,7.63,7.63,0,0,0-1.21,1.3c-.16.22-.3.44-.43.66a6.89,6.89,0,0,0-.49,1c-.09.21-.18.42-.25.62s-.07.21-.1.31c-.14.4-.25.79-.35,1.14C97.68,407.5,89.46,412.75,83.68,417.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M39.78,389.47c8,4.59,20.86,4.59,28.81,0s8-12,0-16.63-20.85-4.6-28.81,0S31.83,384.88,39.78,389.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M435.78,403.43a10.65,10.65,0,0,1-2.9-.42c-2.84-.8-3.72-2.28-4-3.39a5.13,5.13,0,0,1,1.92-4.69c.44-.37,1-.76,1.48-1.17,1.37-1.06,3.08-2.37,3.48-3.39l1.93-4.95-1.46-.84.31-.73-1.51.32-.68-.91c-1.51.73-5.22,2.53-10.19,5l-2.95,1.5a28,28,0,0,1-6.65,2.8,11.54,11.54,0,0,1-2.64.32,5.36,5.36,0,0,1-4.13-1.5,4.1,4.1,0,0,1-.92-3.37c.52-4.66,9.61-8.73,14.33-9.16,1.55-.14,3-.2,4.6-.2.77,0,1.46,0,2.08,0l1.36,0c.42,0,.79,0,1.14,0,1.79-.17,7.35-1.19,7.4-1.2l.61-.12.37.5,1.39-.27c1.84-1.3,15.88-11.26,19.2-13.54,2.07-1.42,5.78-3.67,6.9-3.67h.61l.37.56.28.53-.37.63a27.89,27.89,0,0,1-5.31,6.08c-1.18.94-4.6,3.84-8,6.75l25.66-5-1.13,1.92c-.31.53-2,2.06-10.64,4.62-5.21,1.53-14.73,3.74-21.9,5.34l-1.16,1c-.08,1.28-.34,5.17-.51,7.2a7.69,7.69,0,0,0,.37,2.43c.43,1.72,1,3.85-.43,6A10,10,0,0,1,435.78,403.43Zm1.81-7.4a4.69,4.69,0,0,0-3.37,1.32,1.2,1.2,0,0,0-.34,1,1.55,1.55,0,0,0,1.12.84,4.14,4.14,0,0,0,1.14.15,4.69,4.69,0,0,0,3.37-1.32,1.2,1.2,0,0,0,.34-1,1.55,1.55,0,0,0-1.12-.84A4.14,4.14,0,0,0,437.59,396Zm-13.15-13.64a18.09,18.09,0,0,0-5.54,1c-4.93,1.62-6.48,3.64-7,4.7-.07.13-.2.47-.08.64a1,1,0,0,0,.82.29,2.12,2.12,0,0,0,.49-.06,7.66,7.66,0,0,0,2.55-1.23,32.39,32.39,0,0,1,3.1-1.76,59.55,59.55,0,0,1,8-3.22l.08,0A9.06,9.06,0,0,0,424.44,382.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M483.53,224l-75.64-43.79a4,4,0,0,0-2.87-.59l-.73.41a1.73,1.73,0,0,0,.81,1.95l26.19,15.26-26.12,15.54-26.83-15.62c-1.17-.67-2.39-1.28-3.56-.6h0c-1.17.67-.89,1.25.28,1.93L450.43,243Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Puzzle--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--puzzle--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.07,277.88l-19.85-11.46c-15.42-8.9-22.77-9-23.62-4-.59,3.44-1,5.73-4.77,7.89-6.25,3.61-16.2,3.74-22.75.43,3.5-1.76,7.32-2,12.84-2.32,3.68-.21,5.76-1.09,5.76-2.72V251.21c0-2.21-3.84-5.79-12.72-10.92l-19.85-11.46-21.92,12.66c-8.88,5.12-12.73,8.71-12.73,10.92v14.47c0,1.63,2.08,2.51,5.77,2.72,5.51.31,9.33.56,12.83,2.31-6.54,3.32-16.5,3.18-22.75-.42-3.73-2.16-4.18-4.46-4.76-7.89-.86-5-8.22-4.88-23.63,4L295,280.28v14.47L314.51,306a17.75,17.75,0,0,0-6.36,2.11c-3.25,1.88-4.88,4.34-4.88,6.8V329.4c0,2.46,1.62,4.93,4.88,6.81,6.51,3.76,17.06,3.76,23.57,0,3.73-2.16,4.18-4.45,4.77-7.89.85-5,8.2-4.88,23.62,4L380,343.8l21.92-12.66c15.41-8.89,22.77-9,23.63-4,.59,3.43,1,5.73,4.77,7.88,6.51,3.76,17.05,3.76,23.57,0,3.25-1.88,4.88-4.34,4.88-6.8V313.74c0-2.47-1.63-4.93-4.88-6.81a17.94,17.94,0,0,0-6.37-2.11l21.59-12.47Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.49,306,295,294.75V280.27h0l19.84,11.45c15.4,8.9,15.65,13.15,7,13.64C319,305.52,316.61,305.66,314.49,306Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.46,266.88V252.41c0,1.62,2.1,2.49,5.77,2.7,5.94.34,9.92.6,13.65,2.75,6.51,3.76,6.51,9.85,0,13.61-.27.15-.54.3-.82.44-3.5-1.75-7.32-2-12.83-2.31C351.54,269.39,349.46,268.5,349.46,266.88Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.11,317.86c-15.42-8.91-22.77-9-23.62-4v14.48c.85-5,8.2-4.88,23.62,4L380,343.8V329.31Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.85,320.52c-6.51,3.76-17.07,3.76-23.58,0-3.73-2.16-4.18-4.45-4.76-7.88v14.49c.58,3.43,1,5.73,4.76,7.88,6.51,3.76,17.07,3.76,23.58,0,3.25-1.88,4.88-4.34,4.88-6.8V313.74C458.72,316.19,457.09,318.65,453.85,320.52Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.26,256.66c3.73-2.15,7.71-2.41,13.65-2.75,3.68-.21,5.75-1.09,5.77-2.7v14.47c0,1.63-2.08,2.51-5.77,2.72-5.5.31-9.32.56-12.82,2.31-.28-.13-.56-.29-.83-.44C390.75,266.51,390.75,260.42,397.26,256.66Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.72,321.72c-6.51,3.76-17.06,3.76-23.57,0-3.24-1.87-4.88-4.34-4.89-6.79,0,2.46,0,12,0,14.47s1.63,4.93,4.89,6.81c6.51,3.76,17.06,3.76,23.57,0,3.73-2.16,4.18-4.46,4.77-7.89V313.84C335.9,317.27,335.45,319.57,331.72,321.72Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.88,316.66,380,329.31V343.8l21.92-12.65c15.41-8.91,22.77-9,23.63-4V312.64C424.65,307.62,417.29,307.76,401.88,316.66Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.07,277.88v14.47L447.51,304.8c-2.12-.34-4.5-.47-7.32-.64-8.7-.49-8.46-4.73,7-13.64l21.91-12.64Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.26,256.66c3.74-2.15,7.71-2.41,13.66-2.75,8.69-.49,8.45-4.74-7-13.64l-19.85-11.46-21.92,12.66c-15.42,8.9-15.66,13.14-7,13.64,5.94.34,9.92.6,13.65,2.75,6.51,3.76,6.51,9.85,0,13.61s-17.05,3.76-23.57,0c-3.73-2.16-4.18-4.45-4.76-7.89-.86-5-8.22-4.87-23.63,4L295,280.26l19.85,11.46c15.41,8.9,15.65,13.15,7,13.64-5.95.34-9.93.6-13.66,2.75-6.51,3.76-6.51,9.85,0,13.61s17.06,3.76,23.57,0c3.73-2.16,4.18-4.45,4.77-7.88.85-5,8.2-4.89,23.62,4L380,329.31l21.92-12.65c15.41-8.9,22.77-9,23.63-4,.59,3.43,1,5.73,4.77,7.88,6.51,3.76,17.05,3.76,23.57,0s6.51-9.85,0-13.61c-3.74-2.15-7.71-2.41-13.66-2.75-8.69-.49-8.46-4.74,7-13.64l21.92-12.66-19.85-11.45c-15.42-8.91-22.77-9-23.62-4-.59,3.43-1,5.73-4.77,7.88-6.51,3.76-17.06,3.76-23.57,0S390.75,260.42,397.26,256.66Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.26,256.66c3.74-2.15,7.71-2.41,13.66-2.75,8.69-.49,8.45-4.74-7-13.64l-19.85-11.46-21.92,12.66c-15.42,8.9-15.66,13.14-7,13.64,5.94.34,9.92.6,13.65,2.75,6.51,3.76,6.51,9.85,0,13.61s-17.05,3.76-23.57,0c-3.73-2.16-4.18-4.45-4.76-7.89-.86-5-8.22-4.87-23.63,4L295,280.26l19.85,11.46c15.41,8.9,15.65,13.15,7,13.64-5.95.34-9.93.6-13.66,2.75-6.51,3.76-6.51,9.85,0,13.61s17.06,3.76,23.57,0c3.73-2.16,4.18-4.45,4.77-7.88.85-5,8.2-4.89,23.62,4L380,329.31l21.92-12.65c15.41-8.9,22.77-9,23.63-4,.59,3.43,1,5.73,4.77,7.88,6.51,3.76,17.05,3.76,23.57,0s6.51-9.85,0-13.61c-3.74-2.15-7.71-2.41-13.66-2.75-8.69-.49-8.46-4.74,7-13.64l21.92-12.66-19.85-11.45c-15.42-8.91-22.77-9-23.62-4-.59,3.43-1,5.73-4.77,7.88-6.51,3.76-17.06,3.76-23.57,0S390.75,260.42,397.26,256.66Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.11,231,403,241.9c10.71,6.19,11.68,8.82,11.77,9.23-.18.16-1.05.74-4,.9-6,.34-10.31.59-14.49,3-3.76,2.17-5.82,5.17-5.82,8.44s2.06,6.26,5.82,8.43a27.91,27.91,0,0,0,25.45,0c4.56-2.63,5.11-5.82,5.68-9.2.11-.61.3-1.76,2.86-1.76s7.81,1.23,18,7.1l17,9.82-19.1,11c-13,7.5-14.15,11-13.57,13.39.8,3.38,5.8,3.67,7.44,3.76,6.19.35,9.57.63,12.82,2.51,2.55,1.46,4,3.3,4,5.17s-1.4,3.7-4,5.17a24.15,24.15,0,0,1-21.68,0c-3-1.75-3.31-3.36-3.85-6.57s-2.93-4.89-6.57-4.89c-4.44,0-11.13,2.55-19.86,7.59l-21,12.12-18.91-10.92c-8.73-5-15.41-7.6-19.85-7.6-3.65,0-6,1.79-6.57,4.9s-.82,4.82-3.85,6.57a24.17,24.17,0,0,1-21.69,0c-2.54-1.47-3.94-3.31-3.94-5.17s1.4-3.71,3.94-5.18c3.26-1.88,6.64-2.15,12.82-2.5,1.65-.09,6.64-.38,7.45-3.76.57-2.42-.59-5.9-13.57-13.39l-17-9.83,19.09-11c10.16-5.86,15.38-7.09,18-7.09s2.75,1.15,2.85,1.76c.58,3.38,1.12,6.57,5.68,9.2a27.91,27.91,0,0,0,25.45,0c3.76-2.17,5.83-5.16,5.83-8.43s-2.07-6.27-5.83-8.44c-4.18-2.42-8.5-2.66-14.49-3-2.94-.17-3.8-.75-4-.9.07-.42,1-3,11.78-9.23l21-12.11m0-2.18-21.92,12.66c-15.42,8.9-15.66,13.14-7,13.64,5.94.34,9.92.6,13.65,2.75,6.51,3.76,6.51,9.85,0,13.61a26,26,0,0,1-23.57,0c-3.73-2.16-4.18-4.45-4.76-7.89-.36-2.12-1.9-3.32-4.71-3.32-3.83,0-10,2.22-18.92,7.34L295,280.26l19.85,11.46c15.41,8.9,15.65,13.15,7,13.64-5.95.34-9.93.6-13.66,2.75-6.51,3.76-6.51,9.85,0,13.61a26,26,0,0,0,23.57,0c3.73-2.16,4.18-4.45,4.77-7.88.36-2.13,1.89-3.33,4.71-3.33,3.83,0,10,2.21,18.91,7.34L380,329.31l21.92-12.65c8.88-5.13,15.09-7.35,18.92-7.35,2.82,0,4.35,1.2,4.71,3.33.59,3.43,1,5.73,4.77,7.88a26,26,0,0,0,23.57,0c6.51-3.76,6.51-9.85,0-13.61-3.74-2.15-7.71-2.41-13.66-2.75-8.69-.49-8.46-4.74,7-13.64l21.92-12.66-19.85-11.45c-8.88-5.13-15.08-7.35-18.91-7.35-2.82,0-4.35,1.2-4.71,3.33-.59,3.43-1,5.73-4.77,7.88a26,26,0,0,1-23.57,0c-6.51-3.76-6.51-9.85,0-13.61,3.74-2.15,7.71-2.41,13.66-2.75,8.69-.49,8.45-4.74-7-13.64l-19.85-11.46Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M337.22,202.49l-19.51-11.27a17.75,17.75,0,0,0,6.36-2.11c3.26-1.88,4.88-4.34,4.88-6.8V167.83c0-2.46-1.62-4.92-4.88-6.8-6.51-3.76-17.06-3.76-23.57,0-3.73,2.16-4.18,4.45-4.76,7.88-.86,5-8.21,4.89-23.63-4l-19.85-11.46-21.92,12.65c-8.88,5.13-12.73,8.71-12.73,10.92v14.48c0,1.62,2.08,2.51,5.77,2.72,5.51.31,9.33.56,12.84,2.31-6.55,3.32-16.51,3.18-22.75-.43-3.74-2.15-4.19-4.45-4.77-7.88-.86-5-8.22-4.88-23.63,4l-21.92,12.66v14.47l20,11.57c15.29,8.79,22.58,8.9,23.43,3.91.59-3.44,1-5.73,4.77-7.89,6.25-3.61,16.2-3.74,22.75-.43-3.5,1.76-7.32,2-12.84,2.32-3.68.21-5.76,1.09-5.76,2.72V246c0,2.19,3.79,5.74,12.53,10.81l20,11.57L270,255.75c15.41-8.89,22.77-9,23.63-4,.59,3.43,1,5.72,4.77,7.88,6.51,3.76,17.06,3.76,23.57,0,3.24-1.87,4.87-4.33,4.88-6.78s0-12,0-14.5-1.63-4.92-4.88-6.8a17.75,17.75,0,0,0-6.36-2.11L337.22,217Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.34,228.79c2.81.16,5.18.3,7.3.64h0L337.22,217V202.49L315.3,215.15C299.88,224.05,299.65,228.29,308.34,228.79Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,182.49c-3.73-2.16-7.71-2.42-13.65-2.75-3.74-.22-5.83-1.13-5.77-2.8v14.55c0,1.62,2.08,2.51,5.77,2.72,5.51.31,9.34.56,12.85,2.32a8.71,8.71,0,0,0,.8-.44C243.55,192.34,243.55,186.25,237,182.49Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.07,174.64c-3.73,2.15-7.71,2.41-13.66,2.75-8.69.49-8.45,4.74,7,13.64l.34.19a17.75,17.75,0,0,0,6.36-2.11c3.26-1.88,4.88-4.34,4.88-6.8V167.83C329,170.3,327.33,172.76,324.07,174.64Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.19,216.46l-20-11.57v14.47l20,11.57c15.29,8.79,22.58,8.9,23.43,3.91V220.36C205.77,225.36,198.48,225.25,183.19,216.46Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,212.48c-6.51-3.76-17.06-3.76-23.57,0-3.73,2.15-4.18,4.45-4.77,7.88v14.48c.59-3.44,1-5.73,4.77-7.89,6.25-3.61,16.2-3.74,22.75-.43,0,0,.3-.14.82-.43C241.48,222.34,241.47,216.24,235,212.48Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.88,238.34c0,2.47-1.63,4.93-4.88,6.81-6.51,3.76-17.06,3.76-23.57,0-3.74-2.16-4.18-4.45-4.77-7.89v14.48c.59,3.43,1,5.72,4.77,7.88,6.51,3.76,17.06,3.76,23.57,0,3.24-1.87,4.87-4.33,4.88-6.78S326.88,240.81,326.88,238.34Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,241.28l-21.92,12.66v14.47L270,255.75c15.41-8.89,22.77-9,23.63-4V237.26C292.8,232.24,285.44,232.38,270,241.28Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.07,242.37c-8.92-5.18-12.68-8.76-12.52-11,0,.05,0,.09,0,.14V246c0,2.19,3.79,5.74,12.53,10.81l20,11.57V253.94Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.5,161c-3.73,2.16-4.18,4.45-4.76,7.88-.86,5-8.21,4.89-23.63-4l-19.85-11.46-21.92,12.65c-15.42,8.91-15.66,13.15-7,13.65,5.94.33,9.92.59,13.65,2.75,6.52,3.76,6.52,9.85,0,13.6s-17.05,3.76-23.56,0c-3.74-2.15-4.19-4.45-4.77-7.88-.86-5-8.22-4.88-23.63,4l-21.92,12.66,20,11.57c15.29,8.79,22.58,8.9,23.43,3.9.59-3.43,1-5.73,4.77-7.88,6.51-3.76,17.06-3.76,23.57,0s6.51,9.85,0,13.61c-3.74,2.15-7.71,2.41-13.66,2.75-8.66.49-8.45,4.71,6.77,13.53l20,11.57L270,241.28c15.41-8.9,22.77-9,23.63-4,.59,3.44,1,5.73,4.77,7.89,6.51,3.76,17.06,3.76,23.57,0s6.51-9.85,0-13.61c-3.74-2.15-7.71-2.41-13.66-2.75-8.69-.5-8.46-4.74,7-13.64l21.92-12.66L317.37,191c-15.41-8.9-15.65-13.15-7-13.64,5.95-.34,9.93-.6,13.66-2.75,6.51-3.76,6.51-9.85,0-13.61S307,157.27,300.5,161Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.5,161c-3.73,2.16-4.18,4.45-4.76,7.88-.86,5-8.21,4.89-23.63-4l-19.85-11.46-21.92,12.65c-15.42,8.91-15.66,13.15-7,13.65,5.94.33,9.92.59,13.65,2.75,6.52,3.76,6.52,9.85,0,13.6s-17.05,3.76-23.56,0c-3.74-2.15-4.19-4.45-4.77-7.88-.86-5-8.22-4.88-23.63,4l-21.92,12.66,20,11.57c15.29,8.79,22.58,8.9,23.43,3.9.59-3.43,1-5.73,4.77-7.88,6.51-3.76,17.06-3.76,23.57,0s6.51,9.85,0,13.61c-3.74,2.15-7.71,2.41-13.66,2.75-8.66.49-8.45,4.71,6.77,13.53l20,11.57L270,241.28c15.41-8.9,22.77-9,23.63-4,.59,3.44,1,5.73,4.77,7.89,6.51,3.76,17.06,3.76,23.57,0s6.51-9.85,0-13.61c-3.74-2.15-7.71-2.41-13.66-2.75-8.69-.5-8.46-4.74,7-13.64l21.92-12.66L317.37,191c-15.41-8.9-15.65-13.15-7-13.64,5.95-.34,9.93-.6,13.66-2.75,6.51-3.76,6.51-9.85,0-13.61S307,157.27,300.5,161Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.26,155.61l18.91,10.92c8.73,5,15.41,7.6,19.85,7.6,3.65,0,6-1.79,6.57-4.9s.82-4.82,3.85-6.57a24.17,24.17,0,0,1,21.69,0c2.54,1.47,3.94,3.31,3.94,5.17s-1.4,3.71-3.94,5.18c-3.26,1.88-6.64,2.15-12.82,2.5-1.64.09-6.64.38-7.45,3.76-.57,2.42.59,5.9,13.57,13.39l17,9.83-19.1,11c-13,7.49-14.15,11-13.57,13.39.8,3.38,5.8,3.67,7.44,3.76,6.19.35,9.57.62,12.82,2.5,2.55,1.47,3.95,3.31,3.95,5.17s-1.4,3.71-3.95,5.18a24.23,24.23,0,0,1-21.68,0c-3-1.75-3.31-3.36-3.85-6.57s-2.93-4.9-6.57-4.9c-4.44,0-11.12,2.56-19.86,7.6l-21,12.11-19.1-11c-10.53-6.11-11.49-8.71-11.58-9.12.19-.16,1-.73,4-.9,6-.34,10.3-.59,14.49-3,3.76-2.17,5.82-5.17,5.82-8.44s-2.06-6.26-5.82-8.43a27.91,27.91,0,0,0-25.45,0c-4.57,2.63-5.11,5.82-5.68,9.2-.11.61-.3,1.76-2.86,1.76s-7.74-1.21-17.78-7l-17.21-9.94,19.09-11c10.16-5.86,15.38-7.09,18-7.09s2.75,1.14,2.85,1.76c.58,3.37,1.12,6.56,5.68,9.2a27.93,27.93,0,0,0,25.46,0c3.75-2.17,5.82-5.17,5.82-8.44s-2.07-6.26-5.82-8.43c-4.19-2.42-8.51-2.66-14.49-3-3-.17-3.81-.75-4-.91.07-.42,1-3,11.78-9.22l21-12.12m0-2.17-21.92,12.65c-15.42,8.91-15.66,13.15-7,13.65,5.94.33,9.92.59,13.65,2.75,6.52,3.76,6.52,9.85,0,13.6a26,26,0,0,1-23.56,0c-3.74-2.15-4.19-4.45-4.77-7.88-.36-2.13-1.9-3.33-4.71-3.33-3.83,0-10,2.22-18.92,7.35l-21.92,12.66,20,11.57c8.78,5,14.92,7.23,18.72,7.23,2.82,0,4.35-1.2,4.71-3.33.59-3.43,1-5.73,4.77-7.88a26,26,0,0,1,23.57,0c6.51,3.76,6.51,9.85,0,13.61-3.74,2.15-7.71,2.41-13.66,2.75-8.66.49-8.45,4.71,6.77,13.53l20,11.57L270,241.28c8.88-5.12,15.09-7.34,18.92-7.34,2.82,0,4.35,1.2,4.71,3.32.59,3.44,1,5.73,4.77,7.89a26,26,0,0,0,23.57,0c6.51-3.76,6.51-9.85,0-13.61-3.74-2.15-7.71-2.41-13.66-2.75-8.69-.5-8.46-4.74,7-13.64l21.92-12.66L317.37,191c-15.41-8.9-15.65-13.15-7-13.64,5.95-.34,9.93-.6,13.66-2.75,6.51-3.76,6.51-9.85,0-13.61a26,26,0,0,0-23.57,0c-3.73,2.16-4.18,4.45-4.76,7.88-.37,2.13-1.9,3.33-4.72,3.33-3.82,0-10-2.21-18.91-7.34l-19.85-11.46Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.58,356.1l-19.85-11.46c-15.42-8.9-22.77-9-23.62-4-.59,3.43-1,5.73-4.77,7.88-6.25,3.61-16.2,3.75-22.75.43,3.5-1.75,7.32-2,12.84-2.31,3.68-.21,5.76-1.1,5.76-2.72V329.43c0-2.21-3.84-5.8-12.72-10.93l-19.85-11.45L225.7,319.7c-15.41,8.9-22.77,9-23.63,4-.58-3.43-1-5.73-4.77-7.88-6.51-3.76-17.05-3.76-23.56,0-3.26,1.88-4.89,4.34-4.89,6.8v14.47c0,2.46,1.63,4.93,4.89,6.81A17.82,17.82,0,0,0,180.1,346l-21.59,12.46V373L178,384.23a17.77,17.77,0,0,0-6.36,2.12c-3.25,1.88-4.88,4.34-4.88,6.8v14.47c0,2.46,1.63,4.93,4.88,6.81,6.51,3.75,17.06,3.75,23.57,0,3.73-2.15,4.18-4.45,4.77-7.88.85-5,8.2-4.88,23.62,4L243.47,422l21.92-12.66c8.89-5.13,12.73-8.71,12.73-10.92,0-1.63,0-12.25,0-14.47,0-1.63-2.08-2.51-5.77-2.72-5.51-.31-9.33-.56-12.83-2.32,6.54-3.31,16.5-3.18,22.75.43,3.73,2.16,4.18,4.45,4.76,7.89.86,5,8.22,4.87,23.63-4l21.92-12.66Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.66,368.76c-15.41,8.89-22.77,9-23.63,4v14.48c.86,5,8.22,4.87,23.63-4l21.92-12.66V356.1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.78,348.5c.26.16.54.3.81.44,3.5-1.76,7.32-2,12.84-2.32,3.69-.21,5.76-1.09,5.76-2.72V329.43c0,1.62-2.07,2.5-5.76,2.71-5.95.34-9.92.6-13.65,2.76C254.26,338.65,254.26,344.75,260.78,348.5Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.12,384c0,2.2-3.85,5.79-12.72,10.91l-21.93,12.66V422l21.93-12.66c8.88-5.13,12.72-8.71,12.72-10.92Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.23,400c-6.51,3.76-17.06,3.76-23.57,0-3.25-1.87-4.88-4.34-4.88-6.8v14.47c0,2.46,1.63,4.93,4.88,6.8,6.51,3.77,17.06,3.77,23.57,0,3.73-2.15,4.18-4.45,4.76-7.88V392.07C199.41,395.5,199,397.8,195.23,400Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.27,364.89c-6.52-3.76-17.06-3.76-23.57,0s-6.51,9.85,0,13.6c.27.16.55.3.82.44,6.55-3.31,16.5-3.17,22.75.43,3.73,2.16,4.18,4.46,4.76,7.89V372.77C286.45,369.34,286,367.05,282.27,364.89Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.62,396.09c-15.42-8.9-22.76-9-23.63-4v14.47c.87-5,8.21-4.88,23.63,4L243.47,422V407.55Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.74,343.91A17.45,17.45,0,0,0,180.1,346l.33-.2c15.42-8.9,15.65-13.14,7-13.63-5.95-.34-9.92-.6-13.65-2.76-3.26-1.88-4.89-4.34-4.89-6.8v14.47C168.85,339.57,170.48,342,173.74,343.91Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.31,383.59c8.7-.49,8.46-4.74-6.95-13.64l-19.85-11.46V373L178,384.23C180.13,383.9,182.51,383.75,185.31,383.59Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.77,334.9c3.74-2.16,7.71-2.42,13.66-2.75,8.69-.5,8.45-4.75-7-13.64l-19.85-11.46L225.7,319.7c-15.41,8.9-22.77,9-23.63,4-.58-3.43-1-5.73-4.77-7.88-6.51-3.76-17.05-3.76-23.56,0s-6.52,9.84,0,13.6c3.73,2.16,7.71,2.42,13.65,2.76,8.7.49,8.46,4.73-7,13.64l-21.92,12.65L178.36,370c15.41,8.9,15.65,13.15,7,13.64-5.95.34-9.93.6-13.66,2.76-6.51,3.75-6.51,9.84,0,13.6s17.06,3.76,23.57,0c3.73-2.15,4.18-4.45,4.77-7.88.85-5,8.2-4.89,23.62,4l19.85,11.46,21.92-12.66c15.42-8.9,15.66-13.15,7-13.64-5.94-.34-9.92-.6-13.65-2.75-6.51-3.76-6.51-9.85,0-13.61s17.06-3.76,23.57,0c3.73,2.15,4.18,4.45,4.76,7.88.86,5,8.22,4.88,23.63-4l21.92-12.66-19.85-11.46c-15.42-8.9-22.77-9-23.62-4-.59,3.43-1,5.73-4.77,7.88-6.51,3.76-17.06,3.76-23.57,0S254.26,338.66,260.77,334.9Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.77,334.9c3.74-2.16,7.71-2.42,13.66-2.75,8.69-.5,8.45-4.75-7-13.64l-19.85-11.46L225.7,319.7c-15.41,8.9-22.77,9-23.63,4-.58-3.43-1-5.73-4.77-7.88-6.51-3.76-17.05-3.76-23.56,0s-6.52,9.84,0,13.6c3.73,2.16,7.71,2.42,13.65,2.76,8.7.49,8.46,4.73-7,13.64l-21.92,12.65L178.36,370c15.41,8.9,15.65,13.15,7,13.64-5.95.34-9.93.6-13.66,2.76-6.51,3.75-6.51,9.84,0,13.6s17.06,3.76,23.57,0c3.73-2.15,4.18-4.45,4.77-7.88.85-5,8.2-4.89,23.62,4l19.85,11.46,21.92-12.66c15.42-8.9,15.66-13.15,7-13.64-5.94-.34-9.92-.6-13.65-2.75-6.51-3.76-6.51-9.85,0-13.61s17.06-3.76,23.57,0c3.73,2.15,4.18,4.45,4.76,7.88.86,5,8.22,4.88,23.63-4l21.92-12.66-19.85-11.46c-15.42-8.9-22.77-9-23.62-4-.59,3.43-1,5.73-4.77,7.88-6.51,3.76-17.06,3.76-23.57,0S254.26,338.66,260.77,334.9Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.62,309.22l18.91,10.92c10.71,6.18,11.68,8.81,11.77,9.23-.18.15-1.05.73-4,.9-6,.34-10.31.58-14.49,3-3.76,2.17-5.82,5.16-5.82,8.43s2.06,6.27,5.82,8.44a27.91,27.91,0,0,0,25.45,0c4.56-2.64,5.11-5.83,5.68-9.2.11-.62.3-1.77,2.86-1.77s7.81,1.24,18,7.1l17,9.83-19.1,11c-10.16,5.87-15.38,7.1-18,7.1s-2.75-1.15-2.85-1.76c-.58-3.38-1.12-6.57-5.68-9.2a27.91,27.91,0,0,0-25.45,0c-3.76,2.17-5.83,5.16-5.83,8.43s2.07,6.27,5.83,8.44c4.18,2.41,8.5,2.66,14.49,3,2.94.17,3.8.75,4,.9-.07.42-1,3-11.78,9.23l-21,12.11-18.91-10.91c-8.73-5-15.41-7.6-19.85-7.6-3.65,0-6,1.78-6.57,4.89s-.82,4.82-3.85,6.57a24.17,24.17,0,0,1-21.69,0c-2.54-1.47-3.94-3.3-3.94-5.17s1.4-3.71,3.94-5.17c3.26-1.88,6.64-2.15,12.82-2.51,1.65-.09,6.64-.37,7.45-3.76.57-2.41-.59-5.89-13.57-13.39l-17-9.83,19.09-11c13-7.5,14.15-11,13.57-13.4-.8-3.38-5.8-3.66-7.44-3.75-6.19-.36-9.57-.63-12.82-2.51-2.54-1.46-3.94-3.3-3.94-5.17s1.4-3.71,3.94-5.17a24.15,24.15,0,0,1,21.68,0c3,1.75,3.31,3.36,3.85,6.57s2.93,4.89,6.57,4.89c4.45,0,11.13-2.55,19.86-7.6l21-12.11m0-2.17L225.7,319.7c-8.88,5.13-15.09,7.35-18.92,7.35-2.82,0-4.35-1.2-4.71-3.33-.58-3.43-1-5.73-4.77-7.88a26,26,0,0,0-23.56,0c-6.52,3.76-6.52,9.84,0,13.6,3.73,2.16,7.71,2.42,13.65,2.76,8.7.49,8.46,4.73-7,13.64l-21.92,12.65L178.36,370c15.41,8.9,15.65,13.15,7,13.64-5.95.34-9.93.6-13.66,2.76-6.51,3.75-6.51,9.84,0,13.6a26,26,0,0,0,23.57,0c3.73-2.15,4.18-4.45,4.77-7.88.36-2.13,1.89-3.33,4.71-3.33,3.82,0,10,2.22,18.91,7.35l19.85,11.46,21.92-12.66c15.42-8.9,15.66-13.15,7-13.64-5.94-.34-9.92-.6-13.65-2.75-6.51-3.76-6.51-9.85,0-13.61a26,26,0,0,1,23.57,0c3.73,2.15,4.18,4.45,4.76,7.88.37,2.13,1.9,3.33,4.71,3.33,3.83,0,10-2.22,18.92-7.34l21.92-12.66-19.85-11.46c-8.88-5.13-15.08-7.35-18.91-7.35-2.82,0-4.35,1.2-4.71,3.33-.59,3.43-1,5.73-4.77,7.88a26,26,0,0,1-23.57,0c-6.51-3.75-6.51-9.84,0-13.6,3.74-2.16,7.71-2.42,13.66-2.75,8.69-.5,8.45-4.75-7-13.65l-19.85-11.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201,280.13l-19.51-11.27a17.83,17.83,0,0,0,6.35-2.11c3.26-1.88,4.89-4.35,4.89-6.81V245.47c0-2.46-1.63-4.92-4.89-6.8-6.51-3.76-17.05-3.76-23.56,0-3.74,2.15-4.19,4.45-4.77,7.88-.85,5-8.15,4.88-23.43-3.91l-20-11.57L94.11,243.73c-15.41,8.9-22.76,9-23.62,4-.59-3.43-1-5.73-4.77-7.89-6.51-3.76-17.06-3.76-23.57,0-3.25,1.88-4.88,4.35-4.88,6.81v14.47c0,2.46,1.63,4.92,4.88,6.8a17.77,17.77,0,0,0,6.36,2.12L26.93,282.52V297l19.84,11.46c15.42,8.9,22.77,9,23.63,4,.59-3.43,1-5.73,4.77-7.88,6.24-3.61,16.2-3.75,22.75-.43-3.51,1.75-7.33,2-12.84,2.31-3.69.21-5.76,1.1-5.76,2.72,0,2.21,0,12.85,0,14.48,0,2.21,3.85,5.79,12.72,10.92l19.85,11.46,21.92-12.66c8.89-5.13,12.73-8.72,12.73-10.93,0-1.62,0-12.25,0-14.46,0-1.63-2.08-2.51-5.77-2.72-5.51-.32-9.33-.57-12.84-2.32,6.55-3.31,16.51-3.18,22.75.43,3.74,2.15,4.18,4.45,4.77,7.88.86,5,8.22,4.88,23.63-4L201,294.6Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.08,292.78c-15.41,8.9-22.77,9-23.63,4v14.47c.86,5,8.22,4.88,23.63-4L201,294.6V280.13Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.54,308s0-.08,0-.12c.14,2.2-3.67,5.81-12.72,11l-21.92,12.65v14.48l21.92-12.66c8.89-5.13,12.73-8.72,12.73-10.93C146.53,320.84,146.53,310.21,146.54,308Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.84,252.27c-3.73,2.16-7.71,2.42-13.65,2.76-8.66.49-8.45,4.7,6.76,13.52l.54.31a17.83,17.83,0,0,0,6.35-2.11c3.26-1.88,4.89-4.35,4.89-6.81V245.47h0C192.73,247.93,191.1,250.39,187.84,252.27Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.74,290.11c-6.52-3.76-17.06-3.76-23.57,0-3.74,2.16-4.18,4.46-4.77,7.89v14.47c.59-3.43,1-5.73,4.77-7.88,6.24-3.61,16.2-3.75,22.75-.43l.82-.44C105.25,300,105.25,293.87,98.74,290.11Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.68,288.92c-6.51-3.76-17.05-3.76-23.57,0s-6.51,9.85,0,13.6l.82.44c6.55-3.31,16.51-3.18,22.75.43,3.74,2.15,4.18,4.45,4.77,7.88V296.8C154.86,293.37,154.42,291.07,150.68,288.92Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,320.11c-9.05-5.22-12.86-8.84-12.71-11a.49.49,0,0,0,0,.12c0,2.21,0,12.85,0,14.48,0,2.21,3.85,5.79,12.72,10.92l19.85,11.46V331.57Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.77,294,26.93,282.52V297l19.84,11.46c15.42,8.9,22.77,9,23.63,4V298C69.54,303,62.19,302.88,46.77,294Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.81,256.22c-6-.33-9.92-.59-13.66-2.75-3.25-1.88-4.88-4.34-4.88-6.8v14.47c0,2.46,1.63,4.92,4.88,6.8a17.77,17.77,0,0,0,6.36,2.12l.34-.2C64.27,261,64.5,256.72,55.81,256.22Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.28,238.67c-3.74,2.15-4.19,4.45-4.77,7.88-.85,5-8.15,4.88-23.43-3.91l-20-11.57L94.11,243.73c-15.41,8.9-22.76,9-23.62,4-.59-3.43-1-5.73-4.77-7.89-6.51-3.76-17.06-3.76-23.57,0s-6.51,9.85,0,13.61c3.74,2.16,7.71,2.42,13.66,2.75,8.69.5,8.46,4.74-7,13.64L26.93,282.52,46.77,294c15.42,8.9,22.77,9,23.63,4,.59-3.43,1-5.73,4.77-7.89,6.51-3.76,17-3.76,23.57,0s6.51,9.85,0,13.61c-3.74,2.16-7.71,2.42-13.66,2.75-8.69.5-8.45,4.75,7,13.64l19.85,11.46,21.92-12.65c15.42-8.91,15.65-13.15,7-13.64-6-.34-9.92-.6-13.66-2.76-6.51-3.75-6.51-9.84,0-13.6s17.06-3.76,23.57,0c3.74,2.15,4.18,4.45,4.77,7.88.86,5,8.22,4.88,23.63-4L201,280.13,181,268.55c-15.21-8.82-15.42-13-6.76-13.52,5.94-.34,9.92-.6,13.65-2.76,6.52-3.76,6.52-9.84,0-13.6S170.79,234.91,164.28,238.67Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.28,238.67c-3.74,2.15-4.19,4.45-4.77,7.88-.85,5-8.15,4.88-23.43-3.91l-20-11.57L94.11,243.73c-15.41,8.9-22.76,9-23.62,4-.59-3.43-1-5.73-4.77-7.89-6.51-3.76-17.06-3.76-23.57,0s-6.51,9.85,0,13.61c3.74,2.16,7.71,2.42,13.66,2.75,8.69.5,8.46,4.74-7,13.64L26.93,282.52,46.77,294c15.42,8.9,22.77,9,23.63,4,.59-3.43,1-5.73,4.77-7.89,6.51-3.76,17-3.76,23.57,0s6.51,9.85,0,13.61c-3.74,2.16-7.71,2.42-13.66,2.75-8.69.5-8.45,4.75,7,13.64l19.85,11.46,21.92-12.65c15.42-8.91,15.65-13.15,7-13.64-6-.34-9.92-.6-13.66-2.76-6.51-3.75-6.51-9.84,0-13.6s17.06-3.76,23.57,0c3.74,2.15,4.18,4.45,4.77,7.88.86,5,8.22,4.88,23.63-4L201,280.13,181,268.55c-15.21-8.82-15.42-13-6.76-13.52,5.94-.34,9.92-.6,13.65-2.76,6.52-3.76,6.52-9.84,0-13.6S170.79,234.91,164.28,238.67Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116,233.25l19.1,11c8.64,5,15.25,7.48,19.66,7.48,3.64,0,6-1.78,6.57-4.89s.82-4.82,3.85-6.57a24.15,24.15,0,0,1,21.68,0c2.54,1.47,3.94,3.3,3.94,5.17s-1.4,3.71-3.94,5.17c-3.25,1.88-6.63,2.15-12.82,2.51-1.64.09-6.63.37-7.44,3.75-.57,2.4.57,5.86,13.37,13.28l17.22,9.95-19.1,11c-10.15,5.86-15.37,7.1-18,7.1s-2.75-1.15-2.85-1.77c-.58-3.37-1.12-6.56-5.69-9.19a27.83,27.83,0,0,0-25.45,0c-3.75,2.16-5.82,5.16-5.82,8.43s2.07,6.27,5.82,8.44c4.19,2.41,8.51,2.66,14.49,3,3,.16,3.81.74,4,.9-.07.42-1,3-11.78,9.23l-21,12.11L93,318.48c-10.71-6.18-11.68-8.82-11.77-9.23.18-.16,1.05-.73,4-.9,6-.34,10.3-.58,14.49-3,3.75-2.17,5.82-5.16,5.82-8.43s-2.07-6.27-5.82-8.44A25.86,25.86,0,0,0,87,285.41a25.85,25.85,0,0,0-12.72,3.07c-4.57,2.64-5.11,5.83-5.69,9.2-.1.62-.3,1.76-2.85,1.76s-7.82-1.23-18-7.09l-17-9.83,19.1-11c13-7.49,14.15-11,13.57-13.39-.8-3.38-5.8-3.66-7.44-3.76-6.19-.35-9.57-.62-12.83-2.5-2.54-1.47-3.94-3.3-3.94-5.17s1.4-3.71,3.94-5.17a22,22,0,0,1,10.85-2.57,22,22,0,0,1,10.84,2.57c3,1.74,3.3,3.36,3.85,6.57S71.56,253,75.2,253c4.44,0,11.12-2.56,19.86-7.6l21-12.11m0-2.18L94.11,243.73c-8.87,5.13-15.08,7.35-18.91,7.35-2.82,0-4.35-1.2-4.71-3.33-.59-3.43-1-5.73-4.77-7.89A24.17,24.17,0,0,0,53.94,237a24.1,24.1,0,0,0-11.79,2.82c-6.51,3.76-6.51,9.85,0,13.61,3.74,2.16,7.71,2.42,13.66,2.75,8.69.5,8.46,4.74-7,13.64L26.93,282.52,46.77,294c8.89,5.13,15.09,7.35,18.92,7.35,2.82,0,4.35-1.2,4.71-3.33.59-3.43,1-5.73,4.77-7.89A24.06,24.06,0,0,1,87,287.29a24.1,24.1,0,0,1,11.79,2.82c6.51,3.76,6.51,9.85,0,13.61-3.74,2.16-7.71,2.42-13.66,2.75-8.69.5-8.45,4.75,7,13.64l19.85,11.46,21.92-12.65c15.42-8.91,15.65-13.15,7-13.64-6-.34-9.92-.6-13.66-2.76-6.51-3.75-6.51-9.84,0-13.6a26,26,0,0,1,23.57,0c3.74,2.15,4.18,4.45,4.77,7.88.36,2.13,1.89,3.33,4.71,3.33,3.83,0,10-2.22,18.92-7.35L201,280.13,181,268.55c-15.21-8.82-15.42-13-6.76-13.52,5.94-.34,9.92-.6,13.65-2.76,6.52-3.76,6.52-9.84,0-13.6a26,26,0,0,0-23.56,0c-3.74,2.15-4.19,4.45-4.77,7.88-.36,2.13-1.89,3.33-4.71,3.33-3.8,0-9.94-2.19-18.72-7.24l-20-11.57Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paint-pot--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--paint-pot--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.58,351.93l-34-.46-.29,27.79h0c0,2.52,1.61,5.05,4.91,7,6.6,3.91,17.38,4,24.07.26,3.37-1.9,5.06-4.43,5.06-7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.61,344.58c-6.69,3.77-6.75,10-.15,13.9s17.38,4,24.07.26,6.76-10,.15-13.9S49.3,340.81,42.61,344.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.12,351.82a4.15,4.15,0,0,1-.24,1.33,8.25,8.25,0,0,1-4.08,4.3A23.22,23.22,0,0,1,54.47,360a23,23,0,0,1-11.26-2.79,8.25,8.25,0,0,1-3.94-4.3,4.08,4.08,0,0,1-.24-1.42c0-2.08,1.55-4.08,4.31-5.62a22.77,22.77,0,0,1,11.32-2.55,23,23,0,0,1,11.27,2.8C68.66,347.73,70.14,349.74,70.12,351.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.88,353.15a8.25,8.25,0,0,1-4.08,4.3A23.22,23.22,0,0,1,54.47,360a23,23,0,0,1-11.26-2.79,8.25,8.25,0,0,1-3.94-4.3,8.16,8.16,0,0,1,4.07-4.28,23,23,0,0,1,11.32-2.57,23.28,23.28,0,0,1,11.27,2.81A8.36,8.36,0,0,1,69.88,353.15Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8,357.45a12.61,12.61,0,0,0,1.55-1c-6.21,3.33-16.9,1.93-20.23-.69s-3.78-7.09,1.64-9.09a19.32,19.32,0,0,0-5.42,2,8.16,8.16,0,0,0-4.07,4.28,8.25,8.25,0,0,0,3.94,4.3A23,23,0,0,0,54.47,360,23.22,23.22,0,0,0,65.8,357.45Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.82,362.34c.74-.42,1.34-.06,1.33.79a3,3,0,0,1-1.37,2.32c-.74.42-1.34.06-1.33-.79A3,3,0,0,1,61.82,362.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.49,356.36c-1.87,3.68-5.59,12.46-.76,16,.2.15.39.28.59.41l0,1.78c-.48-.3-1-.63-1.46-1-7.22-5.36.93-19.1,1.28-19.67a.64.64,0,0,1,.41-.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.45,364.24c-.2.43-5.46,10.49-14.11,12.5a12.15,12.15,0,0,1-3,.36,15.1,15.1,0,0,1-8.06-2.52l0-1.78c3.58,2.48,7.17,3.33,10.69,2.52,8-1.87,13.09-11.67,13.13-11.76a.75.75,0,0,1,1-.32A.72.72,0,0,1,62.45,364.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M280.4,437.16q2.24,2.58,7.16,3.69a8.11,8.11,0,0,0,5-.9l97.9-57.19L402,371.11a.89.89,0,0,0-.91-1.47l-21.16,7-98.52,56.84C280.07,434.24,279.42,436,280.4,437.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.7,368.77l18.83-3.69a.59.59,0,0,1,.55,1l-12.77,14.47Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.08,366a.59.59,0,0,0-.55-1l-3.67.72h0a3.25,3.25,0,0,1,1.52,3l0,.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.24,427.58l1.54-.88,1.86-1.06,78.67-45.13a8.51,8.51,0,0,0-.53-6.24c-1.33-3-3.92-5.35-6.07-5.49l-78.63,45.11-3.55,2C300.9,414.73,307.6,426.36,305.24,427.58Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.11,424.24l3.44-2c1-.54.43-3-.75-5.61-1.57-3.43-4.66-6.75-6-6l-2.54,1.46-.89.53c1.34-.71,4.44,2.61,6,6,1.13,2.47,1.71,4.87.85,5.53h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,423.74c2.36-1.25-4.4-12.89-6.76-11.64l-3.45,2c2.36-1.25,9.12,10.39,6.76,11.64Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.24,427.58l3.4-1.94c2.33-1.21-4.1-12.5-6.56-11.75a.48.48,0,0,0-.14.05l-3.41,2C300.9,414.73,307.6,426.36,305.24,427.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.17,365.41l-.64-.33-13.66,7.48-82.5,47.34c-.14-.21-.25-.22-.33-.08,2,3.13,3.52,7.08,2.2,7.76l1.54-.88,1.86-1.06,78.67-45.13h0L400.08,366A.55.55,0,0,0,400.17,365.41Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.8,435.84l14.44-8.26c1-.52.45-3-.72-5.56-1.56-3.43-4.63-6.78-6-6.09h0L284,424.22c-2.87,1.66-.23,7.91,3,10.7C288.2,436,289.54,436.44,290.8,435.84Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.67,431.37c-.83-3.26-3.47-6.45-5.89-7.13a2.34,2.34,0,0,0-2.16.29c-2.17,2,.35,7.75,3.39,10.39a3.47,3.47,0,0,0,3.72.95C291.81,435.24,292.23,433.57,291.67,431.37Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Brushes--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Brush--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--brush--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.31,404.44h0a174,174,0,0,0-14.9,11,123.07,123.07,0,0,0-14.47,14.81v0h0a.67.67,0,0,0-.1.6.68.68,0,0,0,.86.44.42.42,0,0,0,.14-.06h0s10.41-5.8,17.27-11.57A175.76,175.76,0,0,0,99.45,407h0a.88.88,0,0,0,.15-.76,2.59,2.59,0,0,0-1.51-1.79A.87.87,0,0,0,97.31,404.44Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.68,431.35a.42.42,0,0,0,.14-.06h0s10.41-5.8,17.27-11.57c4.62-3.89,9.07-8.31,11.49-10.8L96,407.55s-27.72,23.79-28.13,23.36A.68.68,0,0,0,68.68,431.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.05,405.13c.6-.13,3.87-.81,5.38-2.74a2.68,2.68,0,0,1-.45-.84c-.37-1.17.49-1.72.3-2.63s-1.87-.78-1.88-.77h0a7.18,7.18,0,0,0-3.61,2.45,7.34,7.34,0,0,0-1.48,3.84L99.45,407h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.53,404.52c.19-1.09-.54-1.41-1.1-2.13-1.51,1.93-4.78,2.61-5.38,2.74l.4,1.84c.37-.05.77-.08,1.19-.14l.32-.05.66-.12a9.34,9.34,0,0,0,1-.3c.24-.09.48-.19.73-.31a7.84,7.84,0,0,0,1.5-.94A5.1,5.1,0,0,0,105.53,404.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.53,404.51a3.07,3.07,0,0,0,.28-.35l0,0,.18-.27.06-.11,0-.09a1.09,1.09,0,0,0,.08-.15l.1-.2.18-.44c.05-.15.1-.3.14-.45s.07-.31.1-.46a7.38,7.38,0,0,0-.06-2.84c0-.07,0-.13,0-.2l0-.05-.06-.23a8.65,8.65,0,0,0-.54-1.31,6,6,0,0,0-.3-.52,4,4,0,0,0-.29-.43c0-.07-.09-.12-.13-.18l-.12-.15-.21-.24-.19-.2a2.93,2.93,0,0,1-1.42,2.06,5.63,5.63,0,0,1-.95.48s1.69-.14,1.88.77-.67,1.46-.3,2.63a2.68,2.68,0,0,0,.45.84c.56.72,1.29,1,1.1,2.13Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.77,395.61a7.68,7.68,0,0,1,.26,5.63,3.6,3.6,0,0,1-.6,1.15c.56.72,1.29,1,1.1,2.13h0a3.07,3.07,0,0,0,.28-.35l0,0,.18-.27.06-.11,0-.09a1.09,1.09,0,0,0,.08-.15l.1-.2.18-.44c.05-.15.1-.3.14-.45s.07-.31.1-.46a7.38,7.38,0,0,0-.06-2.84c0-.07,0-.13,0-.2l0-.05-.06-.23a8.65,8.65,0,0,0-.54-1.31,6,6,0,0,0-.3-.52,4,4,0,0,0-.29-.43c0-.07-.09-.12-.13-.18l-.12-.15-.21-.24-.19-.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.45,407a.88.88,0,0,0,.15-.76,2.59,2.59,0,0,0-1.51-1.79.87.87,0,0,0-.78,0c-1.12.68-2.29,1.48-3.49,2.36a1.1,1.1,0,0,1,1,0A3.26,3.26,0,0,1,96.73,409a1,1,0,0,1-.23,1C97.65,408.84,98.73,407.74,99.45,407Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,407.55a3.18,3.18,0,0,1,.78,1.48,1,1,0,0,1-.23,1c1.15-1.18,2.23-2.28,3-3a.88.88,0,0,0,.15-.76,2.42,2.42,0,0,0-.55-1.08h0L96,407.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--brush--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--brush--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.45,402.65h0S93.76,417.87,86,422.83a122.73,122.73,0,0,0-16.26,12.84h0l0,0h0a.67.67,0,0,0-.17.58.68.68,0,0,0,.79.55l.15,0h0s11.07-4.42,18.62-9.27,32.12-22.09,32.12-22.09h0a.88.88,0,0,0,.25-.73,2.59,2.59,0,0,0-1.27-2A.87.87,0,0,0,119.45,402.65Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.7,405.57,119,407c-6,4.18-22.37,15.62-29.12,20l0,0-.73.47c-7.55,4.85-18.62,9.27-18.62,9.27h0l-.15,0a.68.68,0,0,1-.79-.55C69.91,436.76,117.7,405.57,117.7,405.57Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.09,403.56c.61-.05,3.94-.31,5.68-2a2.47,2.47,0,0,1-.34-.89c-.22-1.21.71-1.64.64-2.57s-1.75-1-1.77-1h0a7.22,7.22,0,0,0-3.89,2,7.31,7.31,0,0,0-2,3.62l1.79,2.78h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.59,403.78c.33-1-.36-1.46-.82-2.25-1.74,1.72-5.07,2-5.68,2l.15,1.87,1.2,0h.32l.68,0c.34,0,.7-.09,1.08-.17a6.24,6.24,0,0,0,.76-.21,8.41,8.41,0,0,0,1.61-.74A4.06,4.06,0,0,0,127.59,403.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.6,403.78l.31-.31,0,0c.08-.08.15-.17.22-.25l.08-.1a.56.56,0,0,0,0-.08,1.71,1.71,0,0,0,.11-.14,1.74,1.74,0,0,0,.11-.18,4.49,4.49,0,0,0,.24-.42c.07-.14.14-.28.2-.43s.11-.29.15-.44a7.46,7.46,0,0,0,.32-2.82,1.5,1.5,0,0,1,0-.2v-.06a1.57,1.57,0,0,0,0-.23,7.64,7.64,0,0,0-.37-1.38c-.07-.2-.15-.38-.22-.55s-.16-.32-.23-.46-.07-.14-.11-.2l-.1-.17-.18-.26-.16-.21a2.94,2.94,0,0,1-1.68,1.86,4.9,4.9,0,0,1-1,.34s1.7.08,1.77,1-.86,1.36-.64,2.57a2.47,2.47,0,0,0,.34.89c.46.79,1.15,1.2.82,2.25Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,394.86a7.66,7.66,0,0,1-.46,5.61,3.69,3.69,0,0,1-.75,1.06c.46.79,1.15,1.2.82,2.25h0l.31-.31,0,0c.08-.08.15-.17.22-.25l.08-.1a.56.56,0,0,0,0-.08,1.71,1.71,0,0,0,.11-.14,1.74,1.74,0,0,0,.11-.18,4.49,4.49,0,0,0,.24-.42c.07-.14.14-.28.2-.43s.11-.29.15-.44a7.46,7.46,0,0,0,.32-2.82,1.5,1.5,0,0,1,0-.2v-.06a1.57,1.57,0,0,0,0-.23,7.64,7.64,0,0,0-.37-1.38c-.07-.2-.15-.38-.22-.55s-.16-.32-.23-.46-.07-.14-.11-.2l-.1-.17-.18-.26-.16-.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.24,405.43a.88.88,0,0,0,.25-.73,2.59,2.59,0,0,0-1.27-2,.87.87,0,0,0-.77-.08,37,37,0,0,0-3.8,2.26c.25-.14.64-.48,1-.27a3.24,3.24,0,0,1,1.6,2.49c0,.45-.39.65-.63.82C118.94,406.93,120.43,406.11,121.24,405.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.7,405.57a3.09,3.09,0,0,1,.58,1.56c0,.45-.39.65-.63.82a37.65,37.65,0,0,0,3.59-2.52.89.89,0,0,0,.25-.73,2.45,2.45,0,0,0-.4-1.14l0,0-3.35,2Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--brush--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.73,400.68l17.37-10a1.31,1.31,0,0,0,.54-1.2,4.1,4.1,0,0,0-1.85-3.23,1.29,1.29,0,0,0-1.32-.13l-17.36,10Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.57 393.54 83.84 396.59 76.73 400.68 74.11 396.12 78.57 393.54",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.86,401.84l3.53-2-3.53-2,7.26-4.2a8.74,8.74,0,0,1,7.92,0l6.2,3.59a2.9,2.9,0,0,1,1.63,2.15c0,.08,0,3.58,0,4.35a2.83,2.83,0,0,1-1.63,2.16L73,410Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.24,397.15,74,393.56a8.74,8.74,0,0,0-7.92,0l-7.26,4.2L73,405.93l7.27-4.2C82.42,400.47,82.42,398.42,80.24,397.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.97 405.93 58.86 397.76 48.26 403.86 62.38 412.03 72.97 405.93",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.97 405.93 62.38 412.03 62.37 416.11 72.97 410.01 72.97 405.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.12 404.11 62.01 395.94 63.45 395.1 77.64 403.23 76.12 404.11",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.12 404.11 76.12 408.19 77.64 407.31 77.64 403.23 76.12 404.11",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.12 404.11 76.12 408.19 77.64 407.31 77.64 403.23 76.12 404.11",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.61,414.25s1.93-2.49.9-4.6L62.38,412v4.08Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.61,414.25s1.93-2.49.9-4.6L62.38,412v4.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.51,409.65a5,5,0,0,0-2.89-3.88c-1.93-.83-6,.86-7.71-1.9-1.19-1.94.12-4.48.12-4.48l-7.77,4.47L62.38,412Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.26 403.86 48.26 407.94 62.37 416.11 62.38 412.03 48.26 403.86",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.26 403.86 48.26 407.94 62.37 416.11 62.38 412.03 48.26 403.86",
    style: {
      opacity: 0.15
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Scissors--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--scissors--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438,377.18l39.43-8.73.09,1.06s-.85,1.44-10.06,4.16-32,7.55-32,7.55l-.94-1.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.35,359.69a27.69,27.69,0,0,1-5.1,5.86c-2.75,2.16-17.52,15-17.52,15L439,383.15l-1.43-.83,2.15-5S456.36,365.5,460,363,466.81,359,466.35,359.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.55 381.16 438.97 381.98 438.6 382.93 437.55 382.32 437.55 381.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "466.38 358.41 466.38 359.6 465.19 361.34 465.19 359.5 466.38 358.41",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.29,396.12c1.84-2.85-.3-5.56-.09-8s.53-7.6.53-7.6L439,383.15l-2.24,5.74c-.65,1.71-3.5,3.5-5.24,5s-3.21,5,1.67,6.35S441.46,399,443.29,396.12Zm-8.57,2.18c-1.87-.54-2.44-2.08-1.25-3.44a5.81,5.81,0,0,1,5.54-1.48c1.87.55,2.44,2.09,1.25,3.45A5.78,5.78,0,0,1,434.72,398.3Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.29,396.12c1.84-2.85-.3-5.56-.09-8s.53-7.6.53-7.6L439,383.15l-2.24,5.74c-.65,1.71-3.5,3.5-5.24,5s-3.21,5,1.67,6.35S441.46,399,443.29,396.12Zm-8.57,2.18c-1.87-.54-2.44-2.08-1.25-3.44a5.81,5.81,0,0,1,5.54-1.48c1.87.55,2.44,2.09,1.25,3.45A5.78,5.78,0,0,1,434.72,398.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.49,378.72a2.07,2.07,0,0,1-2,.38c-.72-.21-1-.72-.64-1.13a2,2,0,0,1,2-.38C443.56,377.8,443.85,378.31,443.49,378.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,376.62s-5.64,1-7.5,1.21-4.53-.22-9.18.2-13,4.4-13.42,8.27,3.57,4.15,6.45,3.45,4.47-1.75,9.4-4.21c6.57-3.29,10.94-5.38,10.94-5.38l3.68-3.05Zm-10.92,5.2a61,61,0,0,0-7.83,3.17c-3.14,1.55-3.9,2.61-5.86,3.07-1.6.38-3.18-.52-2.37-2.27s3.21-3.8,7.56-5.23,7.91-1.16,9.49-.32C428.69,380.56,429,381.2,427.09,381.82Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,376.62s-5.64,1-7.5,1.21-4.53-.22-9.18.2-13,4.4-13.42,8.27,3.57,4.15,6.45,3.45,4.47-1.75,9.4-4.21c6.57-3.29,10.94-5.38,10.94-5.38l3.68-3.05Zm-10.92,5.2a61,61,0,0,0-7.83,3.17c-3.14,1.55-3.9,2.61-5.86,3.07-1.6.38-3.18-.52-2.37-2.27s3.21-3.8,7.56-5.23,7.91-1.16,9.49-.32C428.69,380.56,429,381.2,427.09,381.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.49 381.22 435.49 380.06 434.7 379 434.7 380.16 435.49 381.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,376l39.52-7.67s-.85,1.44-10.06,4.16-32,7.55-32,7.55l-.94-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.35,358.53a27.69,27.69,0,0,1-5.1,5.86c-2.75,2.16-17.52,15-17.52,15L439,382l-1.43-.82,2.15-5s16.67-11.82,20.27-14.29S466.81,357.85,466.35,358.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.29,395c1.84-2.84-.3-5.55-.09-8s.53-7.6.53-7.6L439,382l-2.24,5.75c-.65,1.71-3.5,3.5-5.24,5s-3.21,5,1.67,6.35S441.46,397.8,443.29,395Zm-8.57,2.19c-1.87-.54-2.44-2.09-1.25-3.45a5.83,5.83,0,0,1,5.54-1.47c1.87.54,2.44,2.09,1.25,3.45A5.81,5.81,0,0,1,434.72,397.14Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.49,377.56a2.07,2.07,0,0,1-2,.38c-.72-.21-1-.72-.64-1.14a2.07,2.07,0,0,1,2-.37C443.56,376.64,443.85,377.15,443.49,377.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,375.45s-5.64,1-7.5,1.22-4.53-.23-9.18.2-13,4.4-13.42,8.26,3.57,4.16,6.45,3.46,4.47-1.75,9.4-4.22c6.57-3.28,10.94-5.37,10.94-5.37l3.68-3.05Zm-10.92,5.21a61,61,0,0,0-7.83,3.17c-3.14,1.55-3.9,2.61-5.86,3.07-1.6.38-3.18-.52-2.37-2.27s3.21-3.8,7.56-5.23,7.91-1.17,9.49-.33C428.69,379.4,429,380,427.09,380.66Z",
    style: {
      fill: "#9615DB"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ladder--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--ladder--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.51,74.33,407.14,181.5v0a1.42,1.42,0,0,1-.69.74c-1,.58-3.24-.16-2.56-1.49L443.36,73a2.55,2.55,0,0,1,3.26-1.52C447.94,72,447,73,446.51,74.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.56 171.84 394.07 149.04 394.78 145.9 434.27 168.7 433.56 171.84",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.28,90.08,378.9,197.25v0a1.31,1.31,0,0,1-.69.74c-1,.58-3.23-.16-2.56-1.49L415.13,88.75a2.53,2.53,0,0,1,3.26-1.51C419.71,87.72,418.77,88.77,418.28,90.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.28 155.26 422.79 132.47 423.5 129.32 462.99 152.12 462.28 155.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.06,223.15a.86.86,0,0,1-.48.51,3,3,0,0,1-1.53.37,3.11,3.11,0,0,1-1.52-.36,1,1,0,0,1-.48-.57L441.13,60a1.43,1.43,0,0,0-.63-1,.92.92,0,0,0-.33-.06,1.85,1.85,0,0,0-.84.26L418.27,71.32l-2-3.47,21.06-12.16a5.69,5.69,0,0,1,2.84-.8,4.77,4.77,0,0,1,1.95.41,5.24,5.24,0,0,1,2.93,3.81l35,163.58a1.68,1.68,0,0,1,0,.29A1.23,1.23,0,0,1,480.06,223.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.37,223.69l-12.83-7.41a1.69,1.69,0,0,1-.76-1.33v-.3a1.71,1.71,0,0,1,.76-1.33l30.78-17.77a1.72,1.72,0,0,1,1.53,0L482.68,203a1.71,1.71,0,0,1,.76,1.33v.3a1.71,1.71,0,0,1-.76,1.33L451.9,223.69A1.72,1.72,0,0,1,450.37,223.69Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,213.9a1.54,1.54,0,0,0-.22.75v.3a1.69,1.69,0,0,0,.76,1.33l12.83,7.41a1.59,1.59,0,0,0,.77.18v-1.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.14,222.06v1.81a1.58,1.58,0,0,0,.76-.18l15.39-8.89,15.39-8.88a1.71,1.71,0,0,0,.76-1.33v-.3a1.54,1.54,0,0,0-.22-.76Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.81,197.68,432,190.27a1.7,1.7,0,0,1-.77-1.32v-.31a1.72,1.72,0,0,1,.77-1.33l30.78-17.76a1.65,1.65,0,0,1,1.53,0l12.83,7.4a1.71,1.71,0,0,1,.76,1.33v.3a1.71,1.71,0,0,1-.76,1.33l-30.78,17.77A1.72,1.72,0,0,1,444.81,197.68Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.44,187.89a1.56,1.56,0,0,0-.23.75V189a1.7,1.7,0,0,0,.77,1.32l12.83,7.41a1.58,1.58,0,0,0,.76.18v-1.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.57,196.05v1.81a1.59,1.59,0,0,0,.77-.18l15.39-8.89,15.39-8.88a1.71,1.71,0,0,0,.76-1.33v-.3a1.66,1.66,0,0,0-.22-.76Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.25,171.67l-12.83-7.41a1.67,1.67,0,0,1-.77-1.32v-.31a1.66,1.66,0,0,1,.77-1.32l30.77-17.77a1.65,1.65,0,0,1,1.53,0l12.83,7.4a1.69,1.69,0,0,1,.77,1.33v.3a1.68,1.68,0,0,1-.77,1.33l-30.77,17.77A1.72,1.72,0,0,1,439.25,171.67Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.88,161.88a1.56,1.56,0,0,0-.23.75v.31a1.67,1.67,0,0,0,.77,1.32l6.41,3.71,6.42,3.7a1.55,1.55,0,0,0,.76.18V170Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,170v1.81a1.62,1.62,0,0,0,.77-.18l15.38-8.89,15.39-8.88a1.68,1.68,0,0,0,.77-1.33v-.3a1.56,1.56,0,0,0-.23-.76Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.68,145.66l-12.82-7.41a1.66,1.66,0,0,1-.77-1.32v-.31a1.66,1.66,0,0,1,.77-1.32l30.77-17.77a1.65,1.65,0,0,1,1.53,0l12.83,7.4a1.72,1.72,0,0,1,.77,1.33v.3a1.7,1.7,0,0,1-.77,1.33l-30.78,17.77A1.72,1.72,0,0,1,433.68,145.66Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.45,144v1.81a1.55,1.55,0,0,0,.76-.18l15.39-8.89L466,127.89a1.7,1.7,0,0,0,.77-1.33v-.3a1.56,1.56,0,0,0-.23-.75Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.31,135.87a1.65,1.65,0,0,0-.22.75v.31a1.66,1.66,0,0,0,.77,1.32l12.82,7.41a1.59,1.59,0,0,0,.77.18V144Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.12,119.65,406.8,107.34A1.67,1.67,0,0,1,406,106v-.31a1.69,1.69,0,0,1,.76-1.32l30.78-17.77a1.72,1.72,0,0,1,1.53,0l21.32,12.3a1.71,1.71,0,0,1,.76,1.33v.31a1.69,1.69,0,0,1-.76,1.32l-30.78,17.77A1.72,1.72,0,0,1,428.12,119.65Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.89,118v1.81a1.58,1.58,0,0,0,.76-.18L445,110.77l15.39-8.89a1.69,1.69,0,0,0,.76-1.32v-.31a1.54,1.54,0,0,0-.22-.75Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.26,105a1.54,1.54,0,0,0-.22.75V106a1.67,1.67,0,0,0,.76,1.32l21.32,12.31a1.59,1.59,0,0,0,.77.18V118Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.34,239.73a1,1,0,0,1-.47.51,3.05,3.05,0,0,1-1.52.36,3,3,0,0,1-1.53-.36.94.94,0,0,1-.43-.4l-.05-.15,0-.06L412.41,76.55a8.49,8.49,0,0,1,3.86-8.7l2,3.47a4.47,4.47,0,0,0-1.94,4.37l35,163.59a.86.86,0,0,1,0,.31A.82.82,0,0,1,451.34,239.73Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Placard--inject-5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "29.41 167.49 29.41 101.82 147.21 33.95 148.99 34.97 148.99 100.5",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.18 102.85 31.18 168.51 148.98 100.5 148.99 34.97 31.18 102.85",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.33,100.22a.45.45,0,0,1,.58,0,1,1,0,0,1,.24.75v5a2.39,2.39,0,0,1-.24,1,1.59,1.59,0,0,1-.58.71L55,110.8v24a2.46,2.46,0,0,1-.24,1,1.44,1.44,0,0,1-.58.7l-4,2.3a.44.44,0,0,1-.58,0,1,1,0,0,1-.24-.75v-24L44,117.14a.44.44,0,0,1-.58,0,1,1,0,0,1-.25-.75v-5a2.44,2.44,0,0,1,.25-1,1.52,1.52,0,0,1,.58-.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.41,113.34a.43.43,0,0,1,.57,0,1,1,0,0,1,.25.75v5a2.3,2.3,0,0,1-.25,1,1.51,1.51,0,0,1-.57.71L67,129.15a.44.44,0,0,1-.58,0,1,1,0,0,1-.24-.75V98.11a2.45,2.45,0,0,1,.24-1,1.5,1.5,0,0,1,.58-.7l14.17-8.19a.45.45,0,0,1,.58,0A1,1,0,0,1,82,89v5a2.45,2.45,0,0,1-.24,1,1.49,1.49,0,0,1-.58.7l-9.36,5.41v5.06l8.69-5a.44.44,0,0,1,.58,0,1,1,0,0,1,.24.75v5a2.42,2.42,0,0,1-.24,1,1.47,1.47,0,0,1-.58.71l-8.69,5v5.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.26,77.74c.4-.23.71-.24.93,0a1.78,1.78,0,0,1,.44.78l6.63,25.67a2.39,2.39,0,0,1,.12.63,2,2,0,0,1-.2.84,1.24,1.24,0,0,1-.47.58l-3.83,2.21c-.41.24-.7.27-.87.11a1.11,1.11,0,0,1-.32-.59l-.85-3.4-8.09,4.67-.85,4.38a3.58,3.58,0,0,1-.32,1,2.08,2.08,0,0,1-.87.9l-3.83,2.21a.37.37,0,0,1-.47,0,.83.83,0,0,1-.2-.61,4.11,4.11,0,0,1,.12-.78L93,82.92a6.29,6.29,0,0,1,.44-1.28,2.28,2.28,0,0,1,.93-1Zm-4.93,23.31,4.93-2.84L96.8,88.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,89.69a2,2,0,0,1-.41-.53l-2.86-6.08v15.5a2.39,2.39,0,0,1-.24,1,1.53,1.53,0,0,1-.58.71l-4,2.3a.44.44,0,0,1-.58,0,1,1,0,0,1-.25-.75V71.58a2.44,2.44,0,0,1,.25-1,1.52,1.52,0,0,1,.58-.71l3.52-2c.41-.23.71-.23.92,0a3,3,0,0,1,.39.52l4.93,10.13,4.93-15.82c.06-.19.19-.51.39-1a2.16,2.16,0,0,1,.91-1l3.53-2a.44.44,0,0,1,.58,0,1,1,0,0,1,.24.75V89.61a2.42,2.42,0,0,1-.24,1,1.58,1.58,0,0,1-.58.71l-4,2.3a.45.45,0,0,1-.58,0,1,1,0,0,1-.24-.75V77.36l-2.86,9.37a8.59,8.59,0,0,1-.41,1,1.74,1.74,0,0,1-.72.81l-1.94,1.13C121.43,89.85,121.19,89.86,121,89.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.41 101.82 29.41 167.49 31.18 168.51 31.18 102.85 29.41 101.82",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tape--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "147.22 49.48 145.91 50.12 145.85 48.34 144.55 48.98 144.49 47.21 143.19 47.85 143.12 46.08 141.82 46.71 141.76 44.94 140.46 45.58 140.39 43.81 148.23 28.61 149.53 27.98 149.59 29.75 150.9 29.11 150.96 30.88 152.26 30.24 152.32 32.01 153.63 31.38 153.69 33.15 154.99 32.51 155.05 34.28 147.22 49.48",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.22 49.48 145.91 50.12 145.85 48.34 144.55 48.98 144.49 47.21 143.19 47.85 143.12 46.08 141.82 46.71 141.76 44.94 140.46 45.58 140.39 43.81 148.23 28.61 149.53 27.98 149.59 29.75 150.9 29.11 150.96 30.88 152.26 30.24 152.32 32.01 153.63 31.38 153.69 33.15 154.99 32.51 155.05 34.28 147.22 49.48",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tape--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "19.89 99.01 19.54 97.38 20.77 97.16 20.42 95.53 21.65 95.32 21.3 93.69 22.53 93.47 22.18 91.84 23.41 91.63 23.07 90 24.3 89.79 38.81 102.77 39.16 104.4 37.93 104.61 38.28 106.24 37.05 106.46 37.4 108.09 36.16 108.3 36.51 109.93 35.28 110.15 35.63 111.78 34.4 111.99 19.89 99.01",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.89 99.01 19.54 97.38 20.77 97.16 20.42 95.53 21.65 95.32 21.3 93.69 22.53 93.47 22.18 91.84 23.41 91.63 23.07 90 24.3 89.79 38.81 102.77 39.16 104.4 37.93 104.61 38.28 106.24 37.05 106.46 37.4 108.09 36.16 108.3 36.51 109.93 35.28 110.15 35.63 111.78 34.4 111.99 19.89 99.01",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.6,279.44c-.12-2.5-1.13-27.66-1.13-27.66l11.86,9.27c-2.18,14.34-3,18.18-3.13,20.58h0a2,2,0,0,1,.05.61c-.09,2.85-3.35,4.29-5.91,6.12a47.05,47.05,0,0,1-6.91,4.23c-1.85.86-5.55.84-6-.34,3.11-2.25,6.72-4.69,9.22-7.28C364.88,283.73,365.74,282.43,365.6,279.44Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.17,295.16a2.45,2.45,0,0,0,.38,2.47,10.45,10.45,0,0,0,7.62,2,13.31,13.31,0,0,0,7.47-2.73c1.56-1.23,3.74-3,5.47-3.29a10.4,10.4,0,0,0,3.89-1.46c.53-.48.52-2.68.52-2.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.25,280.93a.61.61,0,0,1,.56.53c.1.61.17,2.37.4,3.37a17.83,17.83,0,0,1,.22,5.35c-.24,1.12-2.87,1.83-4.55,2.42a20.85,20.85,0,0,0-5.5,3.25,15.23,15.23,0,0,1-8.11,2.76c-2.93-.11-6.21-1.15-6.93-2.53-.88-1.71-.12-2.67,4.28-4.56.84-.36,3.78-2,4.78-2.58,2.72-1.6,5.43-3.86,6.74-6.8a1.64,1.64,0,0,1,.65-.89,1.37,1.37,0,0,1,.85-.05,7.21,7.21,0,0,1,2.07.69c.58.3,1.4.64,1.37,1.39a2.92,2.92,0,0,1-.19.76c-.06.15-.1.35,0,.44s.29,0,.41-.1a12.21,12.21,0,0,0,1.21-1.37,3.81,3.81,0,0,1,.71-.68,7.39,7.39,0,0,0,.76-.47C373.28,281.61,373.23,281.28,373.25,280.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.38,295.85a28.77,28.77,0,0,1,2.43-1.71h0s-5.21,3-7.23,1.49a1.84,1.84,0,0,1-.6-2.38c0-.36-3.2-2-4.49-2.15h0c-.37.19-.67.34-.87.42-4.4,1.89-5.16,2.85-4.28,4.56.72,1.38,3.08,2.51,6.88,2.62A15.66,15.66,0,0,0,364.38,295.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.36,292.23c-2.73,1-1.59,1.54-.84,1.67s5.39-2.4,8.23-4.52,4.85-4.66,5.95-5.47c.41-.3.86-.67,1.25-1-.05-.6-.09-1.14-.14-1.43a.61.61,0,0,0-.56-.53c0,.35,0,.68-.24.93a7.39,7.39,0,0,1-.76.47,3.81,3.81,0,0,0-.71.68,12.21,12.21,0,0,1-1.21,1.37A35.3,35.3,0,0,1,359.36,292.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.73,293.51a.27.27,0,0,0,.22-.43,6.45,6.45,0,0,0-4.9-2.1.27.27,0,0,0-.25.29.26.26,0,0,0,.29.24,6,6,0,0,1,4.43,1.89A.26.26,0,0,0,358.73,293.51Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.13,292.12a.22.22,0,0,0,.17-.05.27.27,0,0,0,.05-.38,6.47,6.47,0,0,0-4.9-2.09.27.27,0,0,0-.25.28.27.27,0,0,0,.29.25,6,6,0,0,1,4.43,1.89A.25.25,0,0,0,361.13,292.12Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.53,290.82a.28.28,0,0,0,.22-.44,6.48,6.48,0,0,0-4.9-2.09.27.27,0,1,0,0,.53,6,6,0,0,1,4.43,1.89A.29.29,0,0,0,363.53,290.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.76,289.31a.27.27,0,0,0,.17-.06.26.26,0,0,0,.05-.37,6.45,6.45,0,0,0-4.9-2.1.27.27,0,0,0-.25.29.26.26,0,0,0,.29.24,6,6,0,0,1,4.43,1.89A.26.26,0,0,0,365.76,289.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,287.8a.33.33,0,0,0,.16-.05.27.27,0,0,0,.06-.38,6.56,6.56,0,0,0-5.36-2.13.27.27,0,0,0,.05.53,6.11,6.11,0,0,1,4.88,1.92A.26.26,0,0,0,368,287.8Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.39,261.06,402,259.89c.49,8.05-.05,17.08.36,24.64.08,1.42.95,11,.65,14-.44,4.46-5.7,4.29-6.19,1.69s-.81-13.87-.92-15c-.36-4.84-2.59-10.89-4.5-19.47C391.26,265.28,390.48,261.47,390.39,261.06Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,302.2a11.93,11.93,0,0,0,1.36,5.84,3.81,3.81,0,0,0,4.37,1.63c1.76-.41,4-1.56,4.57-3.78a14.32,14.32,0,0,0,.12-6.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.26,283.61c.72.06.88,3.54,1.23,7,.38,3.74,1.46,5.3,1.81,8.36.39,3.5.18,5.05-1.08,7.14s-5.63,4.08-7.71,1c-1.69-2.49-1.71-5.23-1.49-8.71a87.47,87.47,0,0,0,.32-8.87c-.1-2.61-.23-5.15.4-5.43,0,.39.08.88.12,1.25s.09,1.71.49,1.73a6.38,6.38,0,0,0,0-1,1.12,1.12,0,0,1,.21-.84,1.36,1.36,0,0,1,.81-.35c.71-.12,1.43-.24,2.15-.29a9.74,9.74,0,0,1,1.08,0,2.8,2.8,0,0,1,.91.15.66.66,0,0,1,.39.36,1.35,1.35,0,0,1,0,.4,2.94,2.94,0,0,0,.08.72c0,.1.09.23.19.21s.12-.13.13-.21c0-.42,0-.73-.05-1.22,0-.23,0-.54,0-.76S402.28,283.83,402.26,283.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.15,298c.06.51.43,3.85-.49,4.43s-1.48-2-1.48-2a8.78,8.78,0,0,0-5.68.66c.17.54-.38,2.31-1.3,1.92s-1.2-4.22-1.2-4.27c-.2,3.34-.13,6,1.51,8.41,2.08,3.06,6.45,1.07,7.71-1s1.47-3.64,1.08-7.14C405.26,298.64,405.21,298.31,405.15,298Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.91,300.64c0,1.27,1.24.86,1.33-.92s-.81-6-.75-9.09c-.35-3.48-.5-7-1.23-7,0,0,0,.08,0,.12l.06,1.77c0,.26,0,.49,0,.76,0,2.57.24,7.55.42,9.91A40.74,40.74,0,0,1,402.91,300.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.89,301.06a43.26,43.26,0,0,1-.61-4.44c-.2-2.34-.74-7.23-1.19-9.79a6.76,6.76,0,0,1-.23-1.44c0-.35-.07-.79-.11-1.17a.17.17,0,0,1,0-.07c-.46.21-.51,1.6-.47,3.35.07,1,.21,2.26.41,3.78.56,3,.37,7.37.74,9.11S398.11,302.3,397.89,301.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.43,301.19l.1,0a8.54,8.54,0,0,1,5.57-.48.27.27,0,0,0,.15-.51,8.89,8.89,0,0,0-6,.51.27.27,0,0,0-.12.36A.27.27,0,0,0,397.43,301.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.88,298.44l.09,0a10.59,10.59,0,0,1,6.24-.53.26.26,0,0,0,.32-.19.27.27,0,0,0-.19-.33,11,11,0,0,0-6.6.57.27.27,0,0,0-.13.35A.27.27,0,0,0,396.88,298.44Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.08,295.28a.27.27,0,0,0,.23-.18.26.26,0,0,0-.16-.34,9.24,9.24,0,0,0-6.59.5.27.27,0,0,0,.24.48,8.87,8.87,0,0,1,6.16-.48A.25.25,0,0,0,403.08,295.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.94,292.82a.23.23,0,0,0,.22-.17.25.25,0,0,0-.15-.34,8.29,8.29,0,0,0-6.72.48.26.26,0,0,0-.09.36.26.26,0,0,0,.36.1,7.89,7.89,0,0,1,6.26-.44A.25.25,0,0,0,402.94,292.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.77,290.06a.26.26,0,0,0,.07-.51,8.66,8.66,0,0,0-6.76.55.27.27,0,1,0,.26.47,8.24,8.24,0,0,1,6.3-.52A.29.29,0,0,0,402.77,290.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.58,185.76c2.21,5.33,4.64,9.07,4.75,19,.26,21.18-.25,36.46-.25,36.46.11,1.87,1,.86,2.1,10.5a143.2,143.2,0,0,1,.46,18.59s-5.44,2.74-10.4.62c-1.86-6.92-5.08-19.31-7.09-28.56-1.82-8.4-3.54-20.69-3.54-20.69l-3.53,20.67a61.43,61.43,0,0,1,.08,9.44c-.42,5.68-3.36,19.71-3.36,19.71s-5.58,2.33-9.81-.93c0,0-1.6-23-1.53-29.88.15-13.45.85-44.06,3.74-55.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.94,268.33c-2.05,1.24-8.52,2-11.27.88l.72,3.27s1.24.91,5.06.76,5.34-1.7,5.34-1.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.43,268.76c-2.2,1-8.2.86-10.79-.57l.3,3.33s.87,1.27,4.69,1.4,5.23-1,5.23-1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.61,221.71l-2-15s-8.91-1.22-12.1-4.4c0,0,4,5.85,10,6.9l2.32,12.44-1.71,20.54Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.9,151.35c-3.81,0-6.31.62-9.68,6.15s-8.71,14.24-8.71,14.24l-14.45,6,1.19,8.62s10.12-2.64,16-4.92c2.5-1,3.9-1.82,4.75-3.08.71-1,7.61-9.85,7.61-9.85Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.43,151.37l5,.61c3.32.86,4.8,2.35,5.1,5.3a23.11,23.11,0,0,1-.32,9.61c-1.11,4.13-1.76,13.57-1.76,13.57a83.16,83.16,0,0,1,4.93,15.42c-11.94,7.54-29.45,5.2-34.28.46.67-4.83,1.61-9.86,2-13.79a72.77,72.77,0,0,0-.33-9,9.1,9.1,0,0,1-1.65-11.2c4.1-6.19,9.26-11.05,10.77-11Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.43,151.37l5,.61c3.32.86,4.8,2.35,5.1,5.3a23.11,23.11,0,0,1-.32,9.61c-1.11,4.13-1.76,13.57-1.76,13.57a83.16,83.16,0,0,1,4.93,15.42c-11.94,7.54-29.45,5.2-34.28.46.67-4.83,1.61-9.86,2-13.79a72.77,72.77,0,0,0-.33-9,9.1,9.1,0,0,1-1.65-11.2c4.1-6.19,9.26-11.05,10.77-11Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,139.1c.1,1.19-.38,2.13,0,3.32a24.19,24.19,0,0,1,.87,3.13c.29,1.59-.36,4.28-2.35,4.54a3.65,3.65,0,0,0,.39-2.88c-1,3.74-6.06,4-9.42,4-3.1,0-5.89.22-8.65-1.32-1.37-.76-1.49-1.54-1.49-1.54s-.33.31-.19,1.55a2.71,2.71,0,0,1-1.95-2.25,10.32,10.32,0,0,1,.24-4.1c.08-.44.8-4.75,1.06-4.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.06,125.21l-3.29,2.51a2,2,0,0,1,.36-2.8A2.15,2.15,0,0,1,396.06,125.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.89,148.37c.06-2,4.85-4.85,7.41-9s1.59-11.11-1.68-12.3c0,0-.09-.89-.1-1a7.63,7.63,0,0,0-.81-2.32,10,10,0,0,0-6.71-4.73c-10.43-1.89-15.39,2-17.47,6.42a10.92,10.92,0,0,0-1,4.74,5.46,5.46,0,0,0,4.06,5.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.18,124.2c-2.09.82-4.15,3.9-4.42,12.68-.23,7.45,2,9.41,3.12,10s3.3.49,5.5.22l-.06,4.19s-1.7,1.56-1.16,2.59,2.64,2,6,1.05c3.78-1.05,4.72-3.52,4.72-3.52l.4-9.36s1.22,1.37,3.5-.5c1.88-1.54,2.63-4.26,1.31-5.81s-3.08-1.74-4.73-.11l-1.12-.64a21.51,21.51,0,0,1-6.86-2.62A12.41,12.41,0,0,1,373.18,124.2Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.38,147.1c2.31-.19,7.21-1.44,8.05-3.34a5,5,0,0,1-1.79,2.39c-1.48,1.19-6.28,2.36-6.28,2.36Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.37,134.41l-.17,4.14a1.94,1.94,0,0,1-1.92-2.07A2.15,2.15,0,0,1,387.37,134.41Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M380.49,135.2a1.07,1.07,0,0,1-1.06,1.1,1.11,1.11,0,1,1,1.06-1.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370,131.28l2.68-.58a1.31,1.31,0,0,0-1.61-1.06A1.42,1.42,0,0,0,370,131.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.07 133.76 374.99 139.87 371.73 139.02 375.07 133.76",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.67,141.24l-3.22.88a1.62,1.62,0,0,0,2,1.29A1.82,1.82,0,0,0,378.67,141.24Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.83,143.45a1.68,1.68,0,0,1,1.74-1.62l.13,0a1.78,1.78,0,0,1-1.25,1.56A1.46,1.46,0,0,1,376.83,143.45Z",
    style: {
      fill: "#f28f8f"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M372.63,134.48a1,1,0,1,1-1-1A1,1,0,0,1,372.63,134.48Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "335.68 166.25 358.83 174.79 364.84 202.57 364.31 203.12 342.31 194.54 335.15 166.79 335.68 166.25",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.3 175.34 364.31 203.12 364.84 202.57 358.83 174.79 358.3 175.34",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.15 166.79 358.3 175.34 364.31 203.12 342.31 194.54 335.15 166.79",
    style: {
      opacity: 0.25
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M342.08,172.56l-.18-.93c-.1-.51,1.26-.22,3,.65l4.18,1.33c1.78.87,3.47,1.52,3.56,2l.18.93Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M340.76,168.34c-.07-.32.46-.24,1.2,0l1.34.48s-.53-1.35,2.63-.45c3.48,1,3.53,2.74,3.53,2.74a14.71,14.71,0,0,0,1.66.63c1.16.4,1.28.63,1.37,1l.17.59-11.81-4.34S340.82,168.67,340.76,168.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,170.14c1.09.52,1.54.77,1.69,1.56s.21,1.28.21,1.28l6.15,2.53s-.32-1.34-.4-1.78.75-.44,1.81.07l-.24-1.11L341.65,169Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.76,172.57l-.18-.93c-.1-.51,1.26-.22,3,.65l4.19,1.33c1.77.87,3.46,1.53,3.56,2l.17.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.85,189c-.23.54-2,1.71-4.61,1.46l-.41-1.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.6,176.3s.78,3,1,3.82,4,2.59,5.9,2.85c3.64.51,4,1.31,3.13,3.89-.85,2.37-3.24,3.24-6.53,2.8a6,6,0,0,1-4.46-4c-1-3.06-.4-6.32-.8-8.11S336.69,175.22,337.6,176.3Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.65,194.35c-1.3,1-3.08,1.09-5.13,1.89s-3.28,1.62-4.34,1.62-.34,1.68,1,1.75,2.79-.65,2.79-.07c0,.88-1.64,1.71-2.23,2.05-1.83,1.07-4.3,1.62-5.6,3.41a.92.92,0,0,0-.23.64.75.75,0,0,0,.72.54,4.5,4.5,0,0,0,1-.12,1.07,1.07,0,0,1,.91.19c.22.21.28.54.5.73a1.11,1.11,0,0,0,.53.2,3.3,3.3,0,0,0,1,0,6.35,6.35,0,0,1,.86-.12,6,6,0,0,1,1.46.4c2.08.62,4.26-.6,6-1.66,3.63-2.29,4.47-4.25,6.36-5.88s10.16-8.37,13.94-12.31c4-4.12,2.38-4.48.34-9.78s-7.23-15.63-9.12-19.73c-2.17-4.7-4.33-5.45-9-6.15-2.19,2.4-3.23,9.89,2,16.81l6.39,12.82s-1.17,1.39-4.53,5.93C392.81,190.83,391,193.39,389.65,194.35Z",
    style: {
      fill: "#b16668"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Botom--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.94,199.16c-.1-2.65-1.57-29.61-1.57-29.61l12.91,9.68c-2,15.3-2.86,20-3,22.52h0a2,2,0,0,1,.05.65c-.13,3-3.64,4.54-6.41,6.46a50.39,50.39,0,0,1-7.47,4.44c-2,.9-6,.84-6.41-.42,3.37-2.36,7.27-4.92,10-7.66C257.31,203.92,258.07,202.35,257.94,199.16Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.1,216a2.72,2.72,0,0,0,.36,2.63,10.09,10.09,0,0,0,7.63,2.14,13,13,0,0,0,7.53-2.85c1.58-1.3,3.79-3.13,5.53-3.47a10.13,10.13,0,0,0,3.92-1.52c.53-.51.55-2.85.55-2.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.32,201s.42,0,.5.54.2,2.53.42,3.6a20.42,20.42,0,0,1,.28,5.71c-.26,1.18-2.9,1.92-4.6,2.53a21,21,0,0,0-5.55,3.42,15.25,15.25,0,0,1-8.17,2.88c-3.81-.09-6.23-1.27-6.93-2.74-.88-1.83-.54-3.09,3.9-5.07a49.8,49.8,0,0,0,5-2.84,15.07,15.07,0,0,0,5.75-6.9,1.8,1.8,0,0,1,.66-.94,1.4,1.4,0,0,1,.86,0,18.41,18.41,0,0,1,3.46.85c.58.32,1.4.69,1.36,1.49a2.85,2.85,0,0,1-.2.8c-.06.16-.11.37,0,.48s.29,0,.41-.11a12.23,12.23,0,0,0,1.23-1.45,4.09,4.09,0,0,1,.72-.72,7.71,7.71,0,0,0,.77-.49A9.62,9.62,0,0,0,266.32,201Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.05,211.88c5.48.61,7.78,4.37,7.08,7.08a12.53,12.53,0,0,1-3.93.73c-3.81-.09-6.38-1.27-7.09-2.75C241.28,215.22,242.09,213.3,246.05,211.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.52,212.71a.27.27,0,0,0,.17-.06.3.3,0,0,0,.05-.4,6.29,6.29,0,0,0-4.9-2.26.29.29,0,0,0-.25.3.28.28,0,0,0,.29.27,5.81,5.81,0,0,1,4.43,2A.29.29,0,0,0,253.52,212.71Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.74,211.31a.22.22,0,0,0,.17-.05.3.3,0,0,0,.05-.4,6.23,6.23,0,0,0-4.9-2.26.28.28,0,0,0,0,.56,5.84,5.84,0,0,1,4.43,2A.26.26,0,0,0,255.74,211.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.93,209.53a.27.27,0,0,0,.17-.06.29.29,0,0,0,0-.4,6.3,6.3,0,0,0-4.89-2.26.28.28,0,0,0-.25.31.27.27,0,0,0,.28.26,5.83,5.83,0,0,1,4.43,2A.26.26,0,0,0,257.93,209.53Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.09,207.74a.27.27,0,0,0,.17-.06.3.3,0,0,0,.06-.4A6.4,6.4,0,0,0,255,205a.27.27,0,0,0-.25.3.26.26,0,0,0,.28.26,6,6,0,0,1,4.89,2.08A.27.27,0,0,0,260.09,207.74Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.32,177.86l13.6-2.37c.17,8.39-.4,19.58-.67,27.32-.05,1.48.56,11.5.09,14.56-.7,4.61-6.64,4.18-7.08,1.45s-.64-14.35-.72-15.56c-.17-5-2.77-13.57-4.53-22.58C281.92,180.23,281.4,178.29,281.32,177.86Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.11,220.8a11.66,11.66,0,0,0,1.28,6.14,4.52,4.52,0,0,0,4.88,1.9c2-.34,4.62-1.42,5.34-3.7a13.54,13.54,0,0,0,.41-6.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.28,202c.81.11.79,3.62,1,7.25.25,3.9,1.41,5.58,1.66,8.77.28,3.66,0,5.26-1.55,7.37s-6.56,4-8.77.68c-1.8-2.67-1.7-5.52-1.29-9.12a87,87,0,0,0,.77-9.2c0-2.72-.39-5.26.34-5.52,0,.4,0,.91.08,1.3s0,1.78.47,1.82a5,5,0,0,0,.08-1,1.08,1.08,0,0,1,.28-.86,3.07,3.07,0,0,1,1.29-.42c.81-.09,1.63-.18,2.45-.19.41,0,.82,0,1.23,0a3.19,3.19,0,0,1,1,.2.71.71,0,0,1,.42.39,1,1,0,0,1,0,.42,2.71,2.71,0,0,0,.05.75c0,.11.1.24.22.22s.14-.12.14-.21c0-.43,0-.76,0-1.26,0-.24,0-.46,0-.7S294.28,202.18,294.28,202Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.06,220.09a8.32,8.32,0,0,1-1.43,5.44c-1.52,2.1-6.95,3.94-9.16.66a9.55,9.55,0,0,1-1.35-5.39C286.72,218.47,294.91,217.89,297.06,220.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.46,217l.1,0a13,13,0,0,1,7.09-.25.32.32,0,0,0,.38-.18.28.28,0,0,0-.21-.35,13.36,13.36,0,0,0-7.48.26.27.27,0,0,0-.17.36A.32.32,0,0,0,287.46,217Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.63,214a.29.29,0,0,0,.26-.17.26.26,0,0,0-.16-.36,11.31,11.31,0,0,0-7.48.19.27.27,0,0,0-.15.37.32.32,0,0,0,.4.14,10.81,10.81,0,0,1,7-.19A.27.27,0,0,0,294.63,214Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.58,211.45a.28.28,0,0,0,.26-.16.27.27,0,0,0-.15-.37,10.14,10.14,0,0,0-7.63.17.26.26,0,0,0-.12.37.32.32,0,0,0,.41.12,9.62,9.62,0,0,1,7.1-.15A.3.3,0,0,0,294.58,211.45Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.51,208.58a.33.33,0,0,0,.27-.17.26.26,0,0,0-.16-.36,10.53,10.53,0,0,0-7.68.24.26.26,0,0,0-.13.37.3.3,0,0,0,.4.13,10.13,10.13,0,0,1,7.17-.24A.31.31,0,0,0,294.51,208.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.15,112.74c0,15.26,2,45.81,2,45.81.18,1.87,2.57,10.17,2.74,16.94.27,10.88-.15,18.42-.15,18.42s-5.75,2.23-9.91.51c0,0-5.32-21.88-6.7-29-1.66-8.44-5.59-25-5.59-25l-2.77,22.29a71.38,71.38,0,0,1,0,14.49c-.59,4.47-2.2,16.17-2.2,16.17s-5.53,1.85-10.06.35c0,0-1.81-29.1-2.08-33.21s-.23-25.43.74-51.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.57,140.48,270.26,126a12.15,12.15,0,0,1-7.77-3.46s.36,3.33,6.55,5.46l2.12,12-1.36,22.75Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.34,66.28c-3.7.83-6.64,1.74-7.88,8.94-1.1,6.45-3.8,21.88-3.8,21.88s-1.24.31-6.09,1.42c-4.5,1-7,1.94-9.5.87l2.42,9.64c3.94-.16,8.38-.41,13-.76,3.85-.3,7.37-.67,8-2.35,1.22-3,5.7-20.54,5.7-20.54Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.53,65.18c-3.77.37-8,1.56-9.5,7.2-1.13,4.4-2.84,14.08-2.84,14.08a13.38,13.38,0,0,0,10.52,2.85l2.56-12.77Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.58,97a9.32,9.32,0,0,1,7.12-.37c1.2.65,3.22,2.56,4.37,2.77a40.33,40.33,0,0,1-6.95-.41A10.73,10.73,0,0,1,223.58,97Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,108.79a9.85,9.85,0,0,1-4.34.62c-1.35-.1-5.28-3.81-5.28-3.81l5.9-.62Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.49,203.8a2.89,2.89,0,0,0,2.58-.09.89.89,0,0,0,.5-.78L229.64,46.05l-3.64.13,4.93,156.88A.9.9,0,0,0,231.49,203.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.13,46.81a.79.79,0,0,0,0-1.49,2.86,2.86,0,0,0-2.58.1c-.7.43-.67,1.1.06,1.48A2.81,2.81,0,0,0,229.13,46.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.3,37.23h.06a.38.38,0,0,0,.32-.41l-.88-6.59a.36.36,0,1,0-.71.09l.87,6.59A.36.36,0,0,0,214.3,37.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.46,32.86a9.19,9.19,0,0,1,3.21-7.66,2.86,2.86,0,0,1,2.92-.64h0l26.17,11-4.48,10.86-26.18-11h0A2.89,2.89,0,0,1,210.46,32.86Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.84,36.22a9.2,9.2,0,0,0-3.2,7.67c.34,2.63,2.32,3.46,4.43,1.85a9.2,9.2,0,0,0,3.2-7.67C243.93,35.44,242,34.61,239.84,36.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.3,39.74a2.39,2.39,0,0,0-.84,2c.09.68.61.9,1.15.48a2.42,2.42,0,0,0,.84-2C241.36,39.54,240.84,39.32,240.3,39.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.46,50.94a2.06,2.06,0,0,0,1.37-.4,2.54,2.54,0,0,0,.79-2.46l-.92-6.95a.35.35,0,0,0-.41-.31.36.36,0,0,0-.31.4l.92,7A1.56,1.56,0,0,1,238.52,50l-20.26-8.46a6.55,6.55,0,0,1-3.58-4.7.36.36,0,0,0-.72.09,7.31,7.31,0,0,0,4,5.27l20.27,8.47A3.55,3.55,0,0,0,239.46,50.94Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M223.58,97c-1.13.7-1.24,2.58-.65,3.87a11,11,0,0,1,.65,3c.21.86,1.18,1.13,1.18,1.67s-.7.8.43,1.77a6.37,6.37,0,0,0,2.88,1.73,17.39,17.39,0,0,0,3.49-.33c.77-.15.71-1.71-1.48-2.18,0,0,.95,0,1.61,0s1.69-.12.67-1.88-3.13-5.69-4.16-6.59A4.76,4.76,0,0,0,223.58,97Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.5,99.11a18.36,18.36,0,0,1,4.4-1l.6-.08c1.25.68,2.86,4.92,3.86,6.64.54.93.5,1.41.25,1.65-.1-.31-.19-.65-.3-1a4.57,4.57,0,0,0-3.32-3.51,14.36,14.36,0,0,0-3.93-.72C224.15,100.92,223,100,223.5,99.11Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.5,104c.69-.25.39-1.45-.58-2.23a13.22,13.22,0,0,0-2.48-1.48A15.93,15.93,0,0,0,226,99.6c-.2-.07-.48-.1-.61-.26a.59.59,0,0,1,0-.6,1.29,1.29,0,0,1,.61-.49,3.38,3.38,0,0,1,2.85,0,6.83,6.83,0,0,1,1.34,1.29,31.56,31.56,0,0,1,3.68,5c1,1.76-1.47,2.09-2.13,2h0c1.06-.11.75-2.16-1.17-2.61",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.16,105.19a6.69,6.69,0,0,0,1.12.68c.39.19.79.38,1.19.55a3,3,0,0,0,1.3.23,8.19,8.19,0,0,0,1.31-.13c-.44,0-.87,0-1.31,0a4.62,4.62,0,0,1-.64-.06c-.2,0-.41-.12-.61-.19-.41-.15-.81-.33-1.2-.51S225.53,105.42,225.16,105.19Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.71,102.09a13.66,13.66,0,0,0,1.4.88,12.85,12.85,0,0,0,1.49.73,5.76,5.76,0,0,0,1.64.24c.55,0,1.1,0,1.65,0l-1.64-.11a5.72,5.72,0,0,1-1.61-.28,12.43,12.43,0,0,1-1.49-.68C225.67,102.63,225.19,102.37,224.71,102.09Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,100.16a30.7,30.7,0,0,1-5.69-.41A20.39,20.39,0,0,1,232,98a5.72,5.72,0,0,0-4.1-.42c-2.44.5-3.19.77-4.4,1-.46.87.65,1.82,1.56,2a13.9,13.9,0,0,1,3.93.71,4.6,4.6,0,0,1,3.32,3.52c.7,2.28,1.08,4.47,3.84,4.29,3.26-.22,8-.53,10.39-.67Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.9,97.61c-1.49.23-2.94.64-4.41.93h0v0a1,1,0,0,0-.06.74,1.62,1.62,0,0,0,.4.62,2.46,2.46,0,0,0,1.27.67,2.65,2.65,0,0,1-1.21-.73,1.47,1.47,0,0,1-.37-.59.89.89,0,0,1,.07-.66l0,0c.75-.11,1.47-.32,2.2-.5Z",
    style: {
      fill: "#af6152"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.22,76.54c.79-10.91,3.53-10.73,9.8-11.77a34.49,34.49,0,0,1,9.89-.47,67.81,67.81,0,0,1,11.49,2.38l1.86,23V115c-7,4.46-26.84,1.77-34.27-2.71C255.71,105.51,256.63,84.68,257.22,76.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-5"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M279.25,55.13l.19-3.29s-2.1-2.9-2.31-5.27c-.28-3,.37-4.29.37-4.29,1.06-.8,3.44-2.78,4.8-2.9,1.95-.16,3.1,2.7,3.36,3.73a20.15,20.15,0,0,1-.09,7,11.63,11.63,0,0,1-1.9,4.82c-1.08,1.6-2.4,3-3.6,4.54-.1.13-.22.26-.38.25s-.29-.22-.34-.41A15.16,15.16,0,0,1,279.25,55.13Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M282.26,39.17c1.16,4.74-8.61,14.71-13.48,14.66s-8.2-6.49-8.15-11.36,2.07-7.52,9.48-8.9C274.9,32.68,281.18,34.78,282.26,39.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M283.3,56.46a2.58,2.58,0,0,1-3-.52L279.94,66a7.72,7.72,0,0,1-3.55,3.39c-2.43,1-5.5,1.54-7.53.77s-3.09-2.36-.16-4.84l.11-3a17.64,17.64,0,0,1-3.43,0c-2.16-.35-3.51-2.08-4.15-4.43-1-3.78-.73-9.45.77-16.77,2.44-1.86,10.42-2.1,15.5,1.16a16,16,0,0,0,.53,6.46c.15.65,1,2.36,1.53,2.45,1,.16,1.21-1,1.88-1.65a2.83,2.83,0,0,1,4.27,1.21C286.79,53.09,284.8,55.89,283.3,56.46Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.81,62.36c3.46-.32,7.76-1.89,8.88-3.47A11.49,11.49,0,0,0,279.22,56a11.12,11.12,0,0,1-1,4.1c-.85,1.38-4.05,3.71-9.47,4Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.88,49.5a1,1,0,0,0,1,1,1,1,0,1,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.06,45.51l2.17,1a1.24,1.24,0,0,0-.63-1.6A1.16,1.16,0,0,0,271.06,45.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.45,46.27l2.32-.58a1.15,1.15,0,0,0-1.41-.89A1.25,1.25,0,0,0,262.45,46.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.34,49.32a1,1,0,0,0,1,1,1,1,0,0,0,1-1,1,1,0,1,0-1.94,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.73,46.34,283.21,49a2.43,2.43,0,0,0-2.15,1l-5.3-2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,46.88a2,2,0,0,0,.47,1,.9.9,0,0,1,.19.38,19.75,19.75,0,0,0,.66,2.85,3.17,3.17,0,0,0,3.06,2,5.48,5.48,0,0,0,1.05-.09l.08,0a3.2,3.2,0,0,0,.84-.33l.06,0,.07-.05.09-.06.08-.07.09-.07a.73.73,0,0,0,.09-.08l.17-.16a4.61,4.61,0,0,0,.68-1.09c.44-1,.33-2.38,1.05-2.55h.19c1,0,.87,1.53,1.42,2.61A3.71,3.71,0,0,0,272,53.35h.5a3.64,3.64,0,0,0,.51-.08l.17,0,.15,0,.1,0a3.48,3.48,0,0,0,.58-.27l.2-.14a2.28,2.28,0,0,0,.34-.29,3.38,3.38,0,0,0,.64-1,18.66,18.66,0,0,0,.59-2.82,1.25,1.25,0,0,1,.16-.41,2,2,0,0,0,.49-1,.9.9,0,0,0-.6-.9l-.53-.07a16.15,16.15,0,0,0-5.22.07c-1.65.45-2.23,1-3.15,1s-1.42-.57-3-1.09a14.19,14.19,0,0,0-4.89-.25l-.49,0A.84.84,0,0,0,258,46.88Zm10.88,1a1.27,1.27,0,0,1,.47-.39l.09-.05,0,0a1.75,1.75,0,0,1,.24-.11l.21-.09a4.91,4.91,0,0,1,.71-.22l.28-.07c.24,0,.48-.09.73-.12h.16a4.24,4.24,0,0,1,2.95.57c.38.35.21,1.81.06,2.56a.13.13,0,0,0,0,.06s0,0,0,.06a1.28,1.28,0,0,1-.07.3,1.8,1.8,0,0,1-.05.19h0c0,.11-.06.21-.1.32s0,.07-.05.1a.19.19,0,0,0,0,.07.16.16,0,0,0,0,.07.36.36,0,0,0,0,.09l-.06.1-.06.1-.07.11A2.52,2.52,0,0,1,272,52.59a3.06,3.06,0,0,1-2.35-.9,3.29,3.29,0,0,1-.77-1.51A3.38,3.38,0,0,1,268.89,47.92Zm-9.37-.79a1.38,1.38,0,0,1,.39-.24l0,0,.17-.07a.45.45,0,0,0,.11,0l.09,0,.06,0h0l.09,0,.36-.07h.85a6.87,6.87,0,0,1,.73.07,4.42,4.42,0,0,1,2.63,1.16,3.7,3.7,0,0,1,.1,2.26c0,.16-.08.36-.15.56v0l0,.06,0,0s0,0,0,.06a.59.59,0,0,1-.06.14.67.67,0,0,1-.06.12.08.08,0,0,1,0,0,.56.56,0,0,0,0,.08s0,0,0,.06v0a2.51,2.51,0,0,1-2.36,1.08,2.61,2.61,0,0,1-1.19-.29,3.4,3.4,0,0,1-1.56-2.43C259.41,48.94,259.19,47.46,259.52,47.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.31,53.32l3.5.89.57-5.48a.69.69,0,0,0-.46-.16h-.18a.61.61,0,0,0-.2.09C266.49,48.71,263.31,53.32,263.31,53.32Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.61,55.59l-4.06.87A2,2,0,0,0,269,58.12,2.16,2.16,0,0,0,270.61,55.59Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.12,56.25a2.08,2.08,0,0,1,.5,0A2.12,2.12,0,0,1,269,58.12a1.83,1.83,0,0,1-.66,0A1.91,1.91,0,0,1,270.12,56.25Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.45,122.74c1.84.53,4.19-1.76,4.84-2.55s-.19-2.68-.58-4.28,0-4.29-2-3.53S291.63,118.46,295.45,122.74Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.49,67.75c5.28,1,5.53,1.48,8.93,7.5,3.61,6.41,9.17,16.68,10.34,19.19s2.3,4.34-.85,8.21c-2.81,3.44-11.1,13.37-12.33,14.79-1.09,1.26.13,5,3.87,4.42,0,0-2.84,2.52-4.41,2.24-1.35-.24-3.47-1.42-5.42-5.51-1.23-2.59-.2-4.61,1.67-7.49,2.23-3.43,7.06-13,7.06-13l-9.42-15.57S284.14,72.29,288.49,67.75Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.4,66.68c3,.8,4.83,1.12,6.18,3s9.31,16.61,9.31,16.61a11.79,11.79,0,0,1-10.17,6.52l-6.3-9.64S282.47,71.24,288.4,66.68Z",
    style: {
      fill: "#9615DB"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M245.32,379.84c12.18,6.07,17.92,10.17,11.61,14.64s-23.67,12.79-23.67,12.79L231,414.83,206.1,400.44v-8.56s15.37-10.6,21.37-12.64S238.18,376.29,245.32,379.84Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,418.43s3.76,9.23,3.95,12.86c.2,3.8,1.12,5,.48,9.18-.14.89-.61,2.69-.73,3.42a1.08,1.08,0,0,0,1,1.35c1.65.34,4.38-2.75,5.68-6.11a101.12,101.12,0,0,0,3.26-11.86,5.21,5.21,0,0,0-.52-2.66,7.68,7.68,0,0,0-.76-1.37c-.54-1.65-.8-4.79-1.26-7Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.79,430.72a4.07,4.07,0,0,1,.44,1.25c0,.75-1.67,3.24-2.34,4.15a6.09,6.09,0,0,0-1.24,4.31,10.49,10.49,0,0,1-2.53,6.75,16.62,16.62,0,0,1-8.27,5.41c-4,1.23-5.4-.77-5.4-.77s-1.24-1.93-.5-2.72S227.79,430.72,227.79,430.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.29,423.24c.12,0,.34,0,.65.34.12.14.85,1.94,1.45,2.88s2.19,2.73,2.4,4.26c-.93,3-3.71,5-4.12,7.82s-.47,6-4.76,9.46-8.72,3.78-10.3,2.87-1.45-2.61.77-5.84c2.34-3.44,3.93-10.89,3.93-10.9a24,24,0,0,0,.41-3.16,20.83,20.83,0,0,0-.29-3.14,2.28,2.28,0,0,1,.2-1.42,2.39,2.39,0,0,1,1.18-.82,10.87,10.87,0,0,1,2.21-.75,3.55,3.55,0,0,1,2.27.28c.5.27.9.69,1.42.91a2.06,2.06,0,0,0,2.11-.38,1.73,1.73,0,0,0,.57-1.94A3.56,3.56,0,0,0,223.29,423.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,445.26a6.87,6.87,0,0,0-6.23-3.37c-4.56,0-6.14,2.34-6.83,3.71-.83,1.62-1.69,4.57.19,5.41,2,.92,4.39.64,8.1-1.22A9.91,9.91,0,0,0,221.42,445.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.59,431.52a.51.51,0,0,1-.42,0c-.7-.36-4.43-1.14-6.6.87-.29-.22-.23-.64.13-1.22a8.4,8.4,0,0,1,6.92-.46.44.44,0,0,1,.18.61A.5.5,0,0,1,220.59,431.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.1,435.05a1.4,1.4,0,0,1,.26-1.25,8.56,8.56,0,0,1,6.6-.27.45.45,0,0,1,.18.61.5.5,0,0,1-.21.2.51.51,0,0,1-.42,0C218.82,434,215.29,433.25,213.1,435.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.24,441.22a2.63,2.63,0,0,1,.58-1.66,8.45,8.45,0,0,1,6.82-.39.43.43,0,0,1,.17.61.51.51,0,0,1-.21.2.46.46,0,0,1-.41,0C217.44,439.59,213.33,438.75,211.24,441.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.26,437.16a.46.46,0,0,1-.41,0c-.7-.35-4.35-1.11-6.53.82a1.59,1.59,0,0,1,.38-1.35,8.56,8.56,0,0,1,6.6-.27.45.45,0,0,1,.18.61A.53.53,0,0,1,219.26,437.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.9,429.76S205,441,203,445.38s-3.14,6.47-6,9.77c-.62.72-2,2.06-2.55,2.64a1.12,1.12,0,0,0,.12,1.73c1.27,1.22,6.66,1.51,9.68-.76s5.76-7.08,7.56-8.9c.68-.69,1.32-1.39,1.92-2.13s.43-1.39.48-2.2c0-.38,0-1.44,0-1.44.41-1.9,1.53-4.87,2.12-6.72Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.21,452.59a3.92,3.92,0,0,1-.14,1.37c-.3.73-3,2.33-4.07,2.89a6.4,6.4,0,0,0-3.09,3.53,11,11,0,0,1-5.41,5.25,17.42,17.42,0,0,1-10.24,1.43c-4.33-.62-4.77-3.15-4.77-3.15s-.31-2.37.74-2.79S215.21,452.59,215.21,452.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.3,443.5c.12.05.34.11.47.61,0,.19-.07,2.21.08,3.37s.85,3.57.36,5.11c-2.2,2.39-5.74,3.1-7.39,5.55s-3.14,5.51-8.73,6.83-9.93-.32-11-1.88-.2-3.12,3.34-5.19c3.76-2.21,8.59-8.55,8.59-8.55a26,26,0,0,0,1.81-2.82,22.83,22.83,0,0,0,1.12-3.1,2.44,2.44,0,0,1,.82-1.25,2.49,2.49,0,0,1,1.48-.25,11.61,11.61,0,0,1,2.43.28,3.74,3.74,0,0,1,2,1.28c.35.47.54,1.06.93,1.49a2.15,2.15,0,0,0,2.17.59,1.84,1.84,0,0,0,1.41-1.58A4.85,4.85,0,0,0,214.3,443.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.69,463.5a7.15,7.15,0,0,0-4.39-6c-4.32-2-6.85-.53-8.12.45-1.51,1.17-3.64,3.58-2.23,5.22s3.87,2.55,8.2,2.45A10.32,10.32,0,0,0,202.69,463.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,450.12a.5.5,0,0,1-.39-.18c-.51-.66-3.68-3.06-6.64-2.12-.17-.34.07-.71.67-1.1a8.77,8.77,0,0,1,6.76,2.66.45.45,0,0,1-.11.65A.48.48,0,0,1,208,450.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.38,450.12a1.47,1.47,0,0,1,.81-1.07,8.92,8.92,0,0,1,6.36,2.7.45.45,0,0,1-.1.65.46.46,0,0,1-.29.1.49.49,0,0,1-.39-.19C205.27,451.67,202.26,449.4,199.38,450.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.86,455.12a2.79,2.79,0,0,1,1.29-1.3,8.83,8.83,0,0,1,6.63,2.67.46.46,0,0,1-.1.66.52.52,0,0,1-.29.09.47.47,0,0,1-.39-.19C201.46,456.36,198,453.72,194.86,455.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.27,454.87a.51.51,0,0,1-.39-.19c-.5-.65-3.62-3-6.54-2.15a1.68,1.68,0,0,1,1-1.11,9,9,0,0,1,6.37,2.7.46.46,0,0,1-.11.66A.5.5,0,0,1,204.27,454.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.73,365.69c-4.61,3.38-20.68,12.65-27.2,18.69-1.89,1.74-2.51,4-2,9.05.63,6.79,6,29.94,6,29.94.74,1.3,2-1.18,2-1.18l25.46-32.32Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.73,365.69c-4.61,3.38-20.68,12.65-27.2,18.69-1.89,1.74-2.51,4-2,9.05.63,6.79,6,29.94,6,29.94.74,1.3,2-1.18,2-1.18l25.46-32.32Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.56,416.16c5.89-4.92,24.92-35,24.92-35h0c-2.59-2.18-3.93-9.78-3.93-9.78-1,2.93.06,7.35.85,9-1.49,1.3-10,8.26-15.84,12.92a8.42,8.42,0,0,0-3.49,5.26C210.85,404.93,209.42,414.87,209.56,416.16Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.73,365.69h0l32.77,7.25c-1.6,6-2.06,9.12-3.73,12.29s-3.53,6.57-12,10.76c-8.21,4-18.23,8.21-20.24,9.16-1.51.72-2.23,3.74-2.91,7.66-.72,4.11-.78,7.32-4.85,15.95-4,8.44-4.79,10.27-4.79,10.27s-6.16.64-10.25-3c0,0,5.58-28.95,6.77-34.16.66-2.92.68-4.45,4.29-7.65,3.1-2.74,16.94-13.22,16.94-13.22S228.18,373.66,231.73,365.69Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.73,365.69h0l32.77,7.25c-1.6,6-2.06,9.12-3.73,12.29s-3.53,6.57-12,10.76c-8.21,4-18.23,8.21-20.24,9.16-1.51.72-2.23,3.74-2.91,7.66-.72,4.11-.78,7.32-4.85,15.95-4,8.44-4.79,10.27-4.79,10.27s-6.16.64-10.25-3c0,0,5.58-28.95,6.77-34.16.66-2.92.68-4.45,4.29-7.65,3.1-2.74,16.94-13.22,16.94-13.22S228.18,373.66,231.73,365.69Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.47,333.31c-1.93,2.61-11.28,14.17-11.28,14.17-1.9-2.42-4.15-5.39-6.06-8a36.86,36.86,0,0,1-4.71-9.24,26.16,26.16,0,0,0-1.63-3.57,11,11,0,0,1-1.17-3.81c0-.66-1.71-.55-2.12,1.53a14.82,14.82,0,0,0,.2,4.16c-.79-.25-2-.81-3.7-1.31s-5-1.81-5.06.32c0,.48.21,1,.06,1.43a2.93,2.93,0,0,1-.33.6,2.39,2.39,0,0,0,.06,2.45,1.44,1.44,0,0,1,.27.52c.06.39-.22.76-.27,1.13A2.54,2.54,0,0,0,193,335c.26.58.66,1.1.92,1.68a8.26,8.26,0,0,0,.52,1.08,3.27,3.27,0,0,0,1.94,1.57c1.13.37,2.3.77,3.92,1.29,1.29.4,2.22,2.14,3.57,5,3.44,6.71,4.23,7.49,7.55,12.85.33.52.66,1,1,1.39,3.33,4.54,5.22,3.23,10.78-1.66,6.85-6,12.57-12,12.57-12l2.55-20.87C234.3,326.5,230.4,330.69,228.47,333.31Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.08,324.51c-4.33.35-6.23,1.73-8.93,4.4s-9.18,11.2-9.18,11.2-.36,5.13,8.77,10.77l8.56-7.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.76,329.13c1.28.26,1.71,1,1.88,2.82.09,1.06.62,3,1.86,3.64a2.76,2.76,0,0,1-1.57-.49c-.61-.49-.76-.54-1-.19a2.11,2.11,0,0,1-.74.55,1.38,1.38,0,0,1,.3,1.62c-.45,1-3.33.88-5.47.06,0,0,3.81,1,4.46-.09s-1.65-2.63-3-2.84c0,0,3.67.79,4-.31s-1.43-2.13-3.36-2.39c0,0,3.09.57,3.44-.38A1.64,1.64,0,0,0,199.76,329.13Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.19,347.48a16.4,16.4,0,0,1,3.82,9.21s1.05-4.7-2.68-10.61Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.5,337.76c1-10.15,3.41-12.89,8.6-13.38l8.6-.63c2.51.63,11.66,3.68,14.09,5.16,1.71,1,2.29,4.91,2.4,11.2.1,5.11-.05,9.38-.54,16.41a102.14,102.14,0,0,1-3.06,20.74c-7.16,2.34-25.77-.78-33.46-10.46.75-2.74,2.07-5.3,2.68-9.5C233,348.43,233.19,341,233.5,337.76Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.87,299.86a3.22,3.22,0,0,0,.86.7,1.49,1.49,0,0,0-1.35,1.1,2.89,2.89,0,0,0,.16,1.83,5.06,5.06,0,0,0,1.45,2.06,11.77,11.77,0,0,0,2.37,1.21,11.13,11.13,0,0,1,1.5,1.26c.73.55,1.44,1.11,2.17,1.65a45.78,45.78,0,0,0,4.58,2.95,31.57,31.57,0,0,0,4.72,2.19c1.73.63,3.18.06,5,.21l-.23,5s.6-1.16,1.3-2.54c.59-1.19,3.07-7.22,3.07-7.22,1-2.38,2.23-4.86,2.06-7.5-.14-2.14-.58-4-2.21-4.91-.14-2.46-.72-3.66-2.45-5a9.5,9.5,0,0,0-4.28-1.58,17.33,17.33,0,0,0-5.18.21c-4.81.8-9.73,2.19-14.34-.15a4.08,4.08,0,0,0,.34,2.17,10.42,10.42,0,0,0,2.77,3.94l-2.69-.33a.44.44,0,0,0-.3,0,.38.38,0,0,0-.11.29A3.32,3.32,0,0,0,234.87,299.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.74,299c0,1.56,1.52,4.31,3.75,6.22a15.56,15.56,0,0,0-.09,5.27,2.74,2.74,0,0,0,.4,1.06,1.3,1.3,0,0,0,.93.58c.51,0,.72-.28.87-.68a12.23,12.23,0,0,1,.77-1.48,2.86,2.86,0,0,1,.44-.58,2.5,2.5,0,0,1,4.14.83c1.11,2.51-.89,5.87-2.74,6.4-3.17.9-3.88-1.26-3.88-1.26l.13,10.52c-.88,2.68-5.8,5.3-9.78,4.81s-2.73-2.9-1.12-4.54l-.23-3.65a15.46,15.46,0,0,1-4.24-.13c-1.66-.31-3-1.85-3.73-4.35a38.31,38.31,0,0,1-.56-14.61c.58-3,2.17-5,3.06-5.41,0,.65.51,2.2,3.72,2.62C247,301,249.3,300,251.74,299Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.33,322.47a17.69,17.69,0,0,0,6.72-1.86c1.21-.64,2.49-3.25,2.8-3.95,0,0-.07,3.59-1.68,5.11-2.3,2.16-7.75,2.19-7.75,2.19Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.31,304.86l2.56,1.24a1.49,1.49,0,0,0-.68-2A1.38,1.38,0,0,0,248.31,304.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.12,315.17,244,316.65a2.15,2.15,0,0,0,2.77,1.39A2.28,2.28,0,0,0,248.12,315.17Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.66,318.12a1.94,1.94,0,0,1,2-1.82,2,2,0,0,1,.5.1,2.21,2.21,0,0,1-1.41,1.64A2,2,0,0,1,245.66,318.12Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,305.73l2.46-1.33a1.35,1.35,0,0,0-1.86-.56A1.44,1.44,0,0,0,238,305.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.44 314 240.62 312.71 245.02 305.7 244.44 314",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.75,308.25a1.13,1.13,0,0,1-1.14,1.11,1.11,1.11,0,0,1-1.11-1.13,1.13,1.13,0,0,1,1.13-1.12A1.14,1.14,0,0,1,240.75,308.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.74,308.33a1.12,1.12,0,1,1-1.11-1.14A1.12,1.12,0,0,1,249.74,308.33Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.51,385.58a6.07,6.07,0,0,1,1-1.2c3.92-3.63,11.28-8.42,17.53-12.41l28.45,16.43a.26.26,0,0,1,0,.46l-20.66,11.93Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.88,377.23v.46a1.89,1.89,0,0,0,.94,1.63l33.09,19.1a1.87,1.87,0,0,0,.94.25,1.93,1.93,0,0,0,1-.25l18-10.38a1.89,1.89,0,0,0,.94-1.64v-.63h0a.24.24,0,0,1-.12.21l-19.8,11.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.85,397.41v1.26a1.84,1.84,0,0,1-.94-.25l-33.09-19.1a1.89,1.89,0,0,1-.94-1.64v-.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.88,377.22l19.61-11.32a1.14,1.14,0,0,1,1.13,0l34,19.65a.24.24,0,0,1,0,.43l-19.8,11.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.03 395.75 240.61 389.65 209.67 371.79 199.04 377.86 230.03 395.75",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.04 377.86 199.44 378.09 209.68 372.25 240.2 389.88 240.61 389.65 209.68 371.79 199.04 377.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.23 378.78 235.03 378.89 229.85 381.88 220.63 376.56 220.44 376.45 225.82 373.34 235.23 378.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.03 378.89 229.85 381.88 220.63 376.56 225.82 373.56 235.03 378.89",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.81,381c1.66-1.65,4.07-3.93,6.09-4.6a12.4,12.4,0,0,1,1.42-.44,16.3,16.3,0,0,1-2.08-.42,3.61,3.61,0,0,1-1.75-1.16c-.18-.23-.3-.59-.08-.77a.48.48,0,0,1,.29-.1c1.51-.05,2.71-.29,4.08-.39a5.79,5.79,0,0,1,1.86,0c.56.15,1.13.32,1.68.51,2.51.87,4.8,1.65,8.36.82l6.41-3.42s1.37-.34,3.38,3.08.84,5.29.84,5.29L248.12,382h0l-.11,0a23,23,0,0,1-3.39,1.5c-2.24.68-5.11-.13-7.06-.23a20.28,20.28,0,0,0-7.05,1.53c-1.81.73-4-2.05-4.89-1.72S223.15,382.67,224.81,381Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.16,374.92a6.76,6.76,0,0,1,2.76.44,15.33,15.33,0,0,0-3.6.63,16.3,16.3,0,0,1-2.08-.42,3.78,3.78,0,0,1-1.59-1C229.74,375.34,231.85,375.05,233.16,374.92Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.32,397.69a2.22,2.22,0,0,1-1.93-.14l-32.94-19a2.25,2.25,0,0,1-1.09-1.57l-3.61-21.5a2.23,2.23,0,0,1,.64-2l34.22,19.76a1.67,1.67,0,0,1,.81,1.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.85,397.42l-.23.13-.3.14-3.9-23.27a1.67,1.67,0,0,0-.81-1.16L190.39,353.5a2.25,2.25,0,0,1,.45-.35l34.3,19.8a1.7,1.7,0,0,1,.81,1.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.1,373.7l.53-.3a1.7,1.7,0,0,1,.32.71l3.9,23.31-.23.13-.3.14-3.9-23.27A1.74,1.74,0,0,0,225.1,373.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.77,377.84a7.32,7.32,0,0,0-3.32-4.27c-1.6-.92-2.69-.49-2.45.95a7.28,7.28,0,0,0,3.32,4.27C209.91,379.71,211,379.28,210.77,377.84Z",
    style: {
      fill: "#9615DB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M251.09,371.1c5.65-3.46,12.26-7.31,12.26-7.31l-3.73-17.5s-1.47-7.52.56-12,4.73-5,4.73-5a25.86,25.86,0,0,1,4.81,3.16c2,1.78,2.21,6.24,3,11.33s2.34,20.29,2.68,23.28.46,4.42-3.57,6.26c-4.27,2-19.16,7-19.16,7Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.79,328.91a22.57,22.57,0,0,1,4.6,2.83c.67.7,1.81,1.24,2.56,5.13s2.3,15.69,2.3,15.69.22,1.67-4.06,2.69-9.29-.41-9.29-.41-1.87-8.49-2.34-11S257.32,330.94,264.79,328.91Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91,272.32c-.44-.06-.43,1.25-.29,1.82s1.87,2.5,5,3.26,7.59.3,9.48.28,5.12,1,7,1.34,5.28-.2,6.44-1.23a2,2,0,0,0,.51-1.54c0-1.26-.11-1.51-.25-1.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.63,271c.05.25.09.5.13.75a12.5,12.5,0,0,1,.11,3.86,3.47,3.47,0,0,1-2.35,1.62,11.77,11.77,0,0,1-6.41-.14,19.13,19.13,0,0,0-4.85-.67,46.78,46.78,0,0,1-6.59.05,15.45,15.45,0,0,1-4.8-1.19A6,6,0,0,1,91,272.55a4.43,4.43,0,0,1,2.63-4.3,10,10,0,0,1,4.93-.84c1.85.08,3.23.37,4.87.32a8.17,8.17,0,0,0,3.27-.66,3.2,3.2,0,0,0,1.08-1.42c.29-.57.4-1.08.93-1.12,0,0,7.72.14,8.49.24s.94,3.23,1,3.84.06,1,.17,1.46C118.5,270.38,118.57,270.69,118.63,271Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.05,267.36a1,1,0,0,0-.39-.16c-.75-.14-1.35.57-1.69,1.13a5.32,5.32,0,0,0-.43,1.11,2.69,2.69,0,0,0-.08,1.46c0,.12.12.26.25.24s.15-.17.16-.28a5.87,5.87,0,0,1,.63-1.95,2.6,2.6,0,0,1,.49-.7,2.23,2.23,0,0,1,.76-.44c.11,0,.62,0,.5-.24a.28.28,0,0,0-.09-.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.21,267.44a1.38,1.38,0,0,0-1,.24,2.05,2.05,0,0,0-.62,1,3.13,3.13,0,0,0-.15,2.52c.13.23.34.12.42-.09a3.26,3.26,0,0,0,.12-.77,7.12,7.12,0,0,1,.52-1.64,2.69,2.69,0,0,1,.33-.6,1.27,1.27,0,0,1,.35-.3l.2-.08h.21c0-.11-.11-.17-.22-.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.42,266.9a1.26,1.26,0,0,0-.65.4,1.76,1.76,0,0,0-.32.66,6.42,6.42,0,0,0-.36,1.63,2,2,0,0,0,.24,1.13c.07.14.22.27.37.21s.15-.31.16-.45,0-.53,0-.8a4.63,4.63,0,0,1,1-2.66.15.15,0,0,0,0-.13c0-.07-.12-.08-.19-.07A2,2,0,0,0,106.42,266.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.75,267.48c-.76,0-2.4.95-3.26,3.26A13.32,13.32,0,0,0,96,276a7.51,7.51,0,0,1-4.16-2.14,4.46,4.46,0,0,1-1-1.38,4.63,4.63,0,0,1,.91-3.53c1.15-1.29,2.89-2.1,5.59-2.15,3-.06,3.26.75,3.26.75Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.65,259.56s-.24,4-.55,5.81c-.17,1-1.19,2.63-4.4,2.57a3.72,3.72,0,0,1-3.78-2.49,63.69,63.69,0,0,1-.18-7.25Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.67,252.19l-5.06-10.94-9.94,2.46s8.25,12.11,9.08,13.2C158.11,258.71,162.67,252.19,162.67,252.19Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.21,255.34a5.79,5.79,0,0,1,0,1.38l-.36,4.77a10.53,10.53,0,0,1-.26,1.87,11.45,11.45,0,0,0-.08,2.27c0,.79,0,1.58,0,2.37a4.27,4.27,0,0,0,0,1c.08.33-5,3.25-7.07,4.38l-.37.17a3.24,3.24,0,0,1-3.34-.78,5.67,5.67,0,0,1,1.39-6.24s.26,0,.21-2c0-1.43,0-2.88-.16-4.31a9,9,0,0,0-.67-2.61,6.38,6.38,0,0,1-.88-2.42,3.69,3.69,0,0,1,.8-1.68,5.19,5.19,0,0,1,1.25-1.35,9,9,0,0,1,3.6-1.78,1.6,1.6,0,0,1,.81,0c.41.12.65.53.93.86a9.31,9.31,0,0,0,2.3,1.71,4.13,4.13,0,0,1,1.88,2.1C167.17,255.13,167.19,255.24,167.21,255.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.07,266.54a6.57,6.57,0,0,0-.66,1h0a7.2,7.2,0,0,0-.72,5.28c-3.59-.33-4.54-2.4-4.54-2.4a3.46,3.46,0,0,1,1.87-3.1,4.19,4.19,0,0,1,.78-.41l0,0A5.27,5.27,0,0,1,157.07,266.54Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.21,255.86c.94.37.7,3,.1,5.47s-.92,3.37-.62,5.45.48,3-.37,3.78-7.6,3.91-7.6,3.91a24.81,24.81,0,0,0,1.51-7.81c.18-4.61.49-7.58,2.63-9.68A4.06,4.06,0,0,1,168.21,255.86Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.21,255.86c.94.37.7,3,.1,5.47s-.92,3.37-.62,5.45.48,3-.37,3.78-7.6,3.91-7.6,3.91a24.81,24.81,0,0,0,1.51-7.81c.18-4.61.49-7.58,2.63-9.68A4.06,4.06,0,0,1,168.21,255.86Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.14,270.37a12.54,12.54,0,0,0,5.63,2.46c3,.34,3.16-.81,3.48-4.38s.44-8.5,1.84-10.68,3.77-3.13,4.7-2.91c.19-.1,1.11.59,1.42,1a5.19,5.19,0,0,0-4,1.58c-1.88,1.84-2.22,5.73-2.31,9.25s-.24,7.62-3,8.05a10.25,10.25,0,0,1-7.66-2.33A1.43,1.43,0,0,1,151.14,270.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.28,265.23a1,1,0,0,0-.41.65,2,2,0,0,0,1,1.85c.38.22.7.13.09-.61A3.88,3.88,0,0,1,157.28,265.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.22,262.74a.9.9,0,0,0-.25.54,3.05,3.05,0,0,0,1.24,2c.66.29.3-.44,0-.78A12.92,12.92,0,0,1,157.22,262.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.06,260a.58.58,0,0,0-.31.44c0,.29,1.34,1.31,1.76,1.27s.53-.17,0-.52S157.06,260,157.06,260Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.62,252.19S137.77,232,132.44,224.52a18,18,0,0,1-2-4.68c-.65-2.42-4.78-17.31-4.78-17.31l-4.22,21.11a79.72,79.72,0,0,1,1,10.68,48.55,48.55,0,0,1-1.33,12.91c-2.16,10.24-3.54,15.56-3.54,15.56a9,9,0,0,1-4.47,1.12c-4.41,0-4.79-1.87-4.79-1.87s-.71-15.91-1-22.27-.76-12.66-1-16.84c-.31-6.67,0-12.73.62-25,.55-10.86,2.79-28.62,2.79-28.62l29-5.57s6.59,4.65,6.08,20.75c-.35,10.8.65,33.56.65,33.56,5.2,3.6,5.71,6.19,9,14,1.6,3.79,5,11.65,6.15,15.17C156.5,248.37,152.62,252.19,152.62,252.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.7,202.53,129,187.81s4.33-.31,10.23-5c0,0-.55,3.86-8.26,6.85l-3.87,12.51,2.33,13.8Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "121.5 122.4 122.6 133.82 132.81 133.19 132 120.52 121.5 122.4",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.45,109.15s-2.78,4.07-2.49,4.43a5.63,5.63,0,0,0,1.74.73Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.84,99.22c-1.88,1-5.14,1.94-6.6,7.34-.25.93.12,2.37,0,3.54s-.73,2.77-.76,3.82c-.14,5.5,1.44,7.61,2.4,8.51.76.72,4.71,1,6.77.36,2.57-.79,8.15-3.5,10.77-7.71,3.08-5,3.71-11.58.16-14.17A13.44,13.44,0,0,0,120.84,99.22Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.06,122.58a11.53,11.53,0,0,0,5.5.43l-.06-1.46a14.56,14.56,0,0,1-2.6.84A9.54,9.54,0,0,1,116.06,122.58Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.94,97.2c-2.34,1.81-4.45,4.68-3,7.7a4.61,4.61,0,0,0,2.12,2.34,3,3,0,0,0,.36,2.05,3.38,3.38,0,0,0,1.46,1.12.38.38,0,0,1,.14.11.3.3,0,0,1,0,.16c0,.31,0,.62,0,.93a1.23,1.23,0,0,0,.16.73.8.8,0,0,0,.85.24,1.44,1.44,0,0,0,.74-.55c.2-.24.35-.52.55-.77a2.74,2.74,0,0,1,2.06-1.33,2.35,2.35,0,0,1,2.27,1.22,4.72,4.72,0,0,1-.43,3.92,3.08,3.08,0,0,1-2.26,1.67,2.16,2.16,0,0,1-1.7-.71s-.4,4.51,3.26,6a14.17,14.17,0,0,0,7.65-.3c.4-.15,1-1.36,1.33-1.71.56-.68,1.14-1.35,1.72-2a20.78,20.78,0,0,0,2.34-3.53,16,16,0,0,0,1.8-9,11.79,11.79,0,0,0-1.87-4.94C134.85,93.77,124.14,92.41,117.94,97.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.54,127.81c3.79-.89,8,1.8,10.4,7.75s5.74,17.21,6.26,21.28c.28,2.17,1.14,3.5-1.8,4.86a49.23,49.23,0,0,1-13.34,4c.15-.08-3-7.74-3-7.74l7.76-2.41-2.09-6.3Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.79,132.33c-.81-3.15-1.86-5.21-7.84-4.93l-.83,0c-2.13.31-5.11.49-10.59.9-.68.13-4.7.84-5.79,1l-.95.53c-3.63,1.19-6.45,2.8-8.88,13.11-.69,2.92-.28,5.57,3.34,8.38-.09,3,.57,5.53.2,8.39-1.17,9.06-1.93,14.24-1.93,14.24s8.16,3.82,20.51,2.62a25.52,25.52,0,0,0,14.2-5.8,108,108,0,0,0-5.54-12.72C138.9,147.83,144.55,143.14,141.79,132.33Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,129a47.56,47.56,0,0,0-11.66,2.39c-6.61,2.19-16.24,5.31-16.24,5.31s-17.37-7.3-18.23-8.22-1.08-3.33-1.38-4.4a32.43,32.43,0,0,0-1.86-4.78c-.47-1.18-1.84.28-1.75,1.79.13,2,.34,2.81-.15,3.21s-2.76-1.34-6.09-5c-1.94-2.13-3.39-4-4.3-3.2s0,1.71,1.43,3.69a25.82,25.82,0,0,1,1.88,2.71c.18.32-.31.62-.49.81-.35.35-1,.92-1,1.44a4.83,4.83,0,0,1,0,.85c-.15.63-.89,1-1.08,1.58-.13.45.07.93,0,1.39,0,.3-.18.58-.22.87a1.86,1.86,0,0,0,.7,1.57,14.44,14.44,0,0,0,4.26,2.44c1.53.65,3.59.62,5.32,1.71,1.56,1,18.37,12.7,21.88,12.49,3.21-.18,12.51-2,19.11-3.48,7.52-1.63,11.81-7.64,10-14.74C119,129.19,119,129,119,129Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.51,100.46s3.14,1.56,3.24,7.91c.07,4.51.23,10.48.28,16.21s1.54,16.7-.93,18.38c-5.19,3.53-14.4,3.43-19.2,1.92s-2.37-12.19-3-15.76l-3.58.51a11.39,11.39,0,0,1,2.78-4.29,13.16,13.16,0,0,0,4.13-9.31c.91,2.27,3.73,3.07,6.43,1.29S137.51,100.46,137.51,100.46Z",
    style: {
      fill: "#263238"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiate);
export default __webpack_public_path__ + "static/media/initiate.0e65d48c4d3ba51c58ec03fe09145932.svg";
export { ForwardRef as ReactComponent };